export default [
  {
    title: "52nd Street Theme",
    composer: "Thelonious Monk",
    year: 1944,
    rhythm: true
  },
  {
    title: "A Beautiful Friendship",
    composer: "Donald Kahn/Stanley Styne",
    year: 1953
  },
  {
    title: "A Bebop Carol",
    composer: "Tadd Dameron",
    year: 1947
  },
  {
    title: "A Blue Time",
    composer: "Tadd Dameron",
    year: 1961
  },
  {
    title: "A Child is Born",
    composer: "Thad Jones/Alec Wilder",
    year: 1969,
    waltz: true,
    ballad: true,
    holiday: true
  },
  {
    title: "A Fine Romance",
    composer: "Jerome Kern/Dorothy Fields",
    year: 1936
  },
  {
    title: "A Flower is a Lovesome Thing",
    composer: "Billy Strayhorn",
    year: 1944,
    ballad: true
  },
  {
    title: "A Foggy Day (in London Town)",
    composer: "George Gershwin/Ira Gershwin",
    year: 1937
  },
  {
    title: "A Gal in Calico",
    composer: "Arthur Schwartz/Leo Robin",
    year: 1946
  },
  {
    title: "A Handful of Keys",
    composer: "Fats Waller",
    year: 1929
  },
  {
    title: "A Kiss to Build a Dream On",
    composer: "Bert Kalmar, Harry Ruby/Oscar Hammerstein II",
    year: 1935
  },
  {
    title: "A Night in Tunisia",
    composer: "Dizzy Gillespie & Frank Paparelli",
    year: 1942,
    latin: true
  },
  {
    title: "A Nightingale Sang in Berkeley Square",
    composer: "Manning Sherwin/Eric Maschwitz",
    year: 1939,
    ballad: true
  },
  {
    title: "A Shade of Jade",
    composer: "Joe Henderson",
    year: 1966
  },
  {
    title: "A Sleepin' Bee",
    composer: "Harold Arlen/Truman Capote",
    year: 1954
  },
  {
    title: "A Time for Love",
    composer: "Johnny Mandel/Paul Francis Webster",
    year: 1966
  },
  {
    title: "A Tribute to Someone",
    composer: "Herbie Hancock",
    year: 1963
  },
  {
    title: "A Weaver of Dreams",
    composer: "Victor Young/John Elliot",
    year: 1951
  },
  {
    title: "Afro Blue",
    composer: "Mongo Santamaria",
    year: 1959,
    waltz: true,
    latin: true
  },
  {
    title: "After Hours",
    composer: "Avery Parrish",
    year: 1940,
    blues: true
  },
  {
    title: "After You've Gone",
    composer: "Turner Layton/Henry Creamer",
    year: 1918
  },
  {
    title: "Afternoon in Paris",
    composer: "John Lewis",
    year: 1949
  },
  {
    title: "Ah-Leu-Cha",
    composer: "Charlie Parker",
    year: 1948,
    miles: true,
    contrafact: true
  },
  {
    title: "Ahmad's Blues",
    composer: "Ahmad Jamal",
    year: 1955,
    blues: true
  },
  {
    title: "Ain't Misbehavin'",
    composer: "Fats Waller/Andy Razaf & Harry Brooks",
    year: 1929
  },
  {
    title: "Airegin",
    composer: "Sonny Rollins",
    year: 1954,
    miles: true
  },
  {
    title: "Alfie",
    composer: "Burt Bacharach/Hal David",
    year: 1966,
    ballad: true
  },
  {
    title: "Alice in Wonderland",
    composer: "Sammy Fain/Bob Hilliard",
    year: 1951,
    waltz: true
  },
  {
    title: "All At Once You Love Her",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1955
  },
  {
    title: "All Blues",
    composer: "Miles Davis",
    year: 1959,
    waltz: true
  },
  {
    title: "All God's Chillun Got Rhythm",
    composer: "Bronislaw Kaper & Walter Jurmann/Gus Kahn",
    year: 1937
  },
  {
    title: "All I Want for Christmas is You",
    composer: "Walter Afanasieff & Mariah Carey",
    year: 1994,
    holiday: true
  },
  {
    title: "All My Tomorrows",
    composer: "Jimmy Van Heusen/Sammy Cahn",
    year: 1959,
    ballad: true
  },
  {
    title: "All of Me",
    composer: "Gerald Marks & Seymour Simons",
    year: 1931
  },
  {
    title: "All of You",
    composer: "Cole Porter",
    year: 1954,
    miles: true
  },
  {
    title: "All or Nothing at All",
    composer: "Arthur Altman/Jack Lawrence",
    year: 1939
  },
  {
    title: "All the Things You Are",
    composer: "Jerome Kern/Oscar Hammerstein II",
    year: 1939
  },
  {
    title: "All the Way",
    composer: "Jimmy Van Heusen/Sammy Cahn",
    year: 1957,
    ballad: true
  },
  {
    title: "All Through the Night",
    composer: "Cole Porter",
    year: 1934
  },
  {
    title: "All Too Soon",
    composer: "Duke Ellington/Carl Sigman",
    year: 1940,
    ballad: true
  },
  {
    title: "Almost Like Being in Love",
    composer: "Frederick Loewe/Alan Jay Lerner",
    year: 1947
  },
  {
    title: "Alone and I",
    composer: "Herbie Hancock",
    year: 1962,
    ballad: true
  },
  {
    title: "Alone Together",
    composer: "Arthur Schwartz/Howard Dietz",
    year: 1932,
    minor: true
  },
  {
    title: "Alone Too Long",
    composer: "Arthur Schwartz/Dorothy Fields",
    year: 1954,
    ballad: true
  },
  {
    title: "Along Came Betty",
    composer: "Benny Golson",
    year: 1958
  },
  {
    title: "Always",
    composer: "Irving Berlin",
    year: 1925,
    waltz: true
  },
  {
    title: "Am I Blue?",
    composer: "Harry Akst/Grant Clarke",
    year: 1929
  },
  {
    title: "An Affair To Remember",
    composer: "Harry Warren/Harold Adamson & Leo McCarey",
    year: 1957
  },
  {
    title: "An Oscar for Treadwell",
    composer: "Charlie Parker",
    year: 1950,
    rhythm: true
  },
  {
    title: "Angel Eyes",
    composer: "Matt Dennis/Earl K. Brent",
    year: 1946
  },
  {
    title: "Angel Face",
    composer: "Hank Jones",
    year: 1947,
    ballad: true
  },
  {
    title: "Angels We Have Heard on High",
    composer: "James Chadwick",
    year: 1862,
    holiday: true
  },
  {
    title: "Another Hair Do",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Anthropology",
    composer: "Charlie Parker & Dizzy Gillespie",
    year: 1945,
    rhythm: true
  },
  {
    title: "Anything Goes",
    composer: "Cole Porter",
    year: 1934
  },
  {
    title: "April in Paris",
    composer: "Vernon Duke/Yip Harburg",
    year: 1932
  },
  {
    title: "Are You Real?",
    composer: "Benny Golson",
    year: 1958
  },
  {
    title: "As Long As I Live",
    composer: "Harold Arlen/Ted Koehler",
    year: 1934
  },
  {
    title: "As Time Goes By",
    composer: "Herman Hupfeld",
    year: 1926
  },
  {
    title: "Ask Me Now",
    composer: "Thelonious Monk",
    year: 1951
  },
  {
    title: "Au Privave",
    composer: "Charlie Parker",
    year: 1951
  },
  {
    title: "Audobon",
    composer: "Sonny Rollins",
    year: 1949,
    contrafact: true
  },
  {
    title: "Audrey",
    composer: "Bud Powell",
    year: 1953
  },
  {
    title: "Autumn in New York",
    composer: "Vernon Duke",
    year: 1934,
    ballad: true
  },
  {
    title: "Autumn Leaves",
    composer: "Joseph Kosma/Johnny Mercer & Jacques Prevert",
    year: 1947
  },
  {
    title: "Autumn Nocturne",
    composer: "Josef Myrow/Kim Gannon",
    year: 1941,
    ballad: true
  },
  {
    title: "Autumn Serenade",
    composer: "Peter DeRose/Sammy Gallop",
    year: 1945,
    latin: true
  },
  {
    title: "Avalon",
    composer: "Al Jolson, Buddy DeSylva, Vincent Rose",
    year: 1920
  },
  {
    title: "Away in a Manger",
    composer: "James R. Murray",
    year: 1887,
    holiday: true
  },
  {
    title: "Baby, It's Cold Outside",
    composer: "Frank Loesser",
    year: 1944,
    holiday: true
  },
  {
    title: "Back Home Blues",
    composer: "Charlie Parker",
    year: 1951,
    blues: true
  },
  {
    title: "Back to Bologna",
    composer: "Cedar Walton",
    year: 1981
  },
  {
    title: "Back to the Land",
    composer: "Lester Young",
    year: 1951
  },
  {
    title: "Bags' Groove",
    composer: "Milt Jackson",
    year: 1954,
    blues: true
  },
  {
    title: "Bali Ha'i",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1949,
    latin: true
  },
  {
    title: "Ba-lue Bolivar Ba-lues-are",
    composer: "Thelonious Monk",
    year: 1956,
    blues: true
  },
  {
    title: "Barbados",
    composer: "Charlie Parker",
    year: 1945,
    blues: true
  },
  {
    title: "Barry's Bop",
    composer: "Tadd Dameron",
    year: 1947
  },
  {
    title: "Basin Street Blues",
    composer: "Spencer Williams",
    year: 1928
  },
  {
    title: "Baubles, Bangles, and Beads",
    composer: "George Forrest/Robert Wright",
    year: 1953,
    waltz: true
  },
  {
    title: "Be My Love",
    composer: "Nicholas Brodzsky/Sammy Cahn",
    year: 1950
  },
  {
    title: "Bean and the Boys",
    composer: "Coleman Hawkins",
    year: 1949,
    contrafact: true
  },
  {
    title: "Beautiful Love",
    composer: "Victor Young, Wayne King, Egbert Van Alstyne/Haven Gillespie",
    year: 1931
  },
  {
    title: "Beautiful Moons Ago",
    composer: "Oscar Moore",
    year: 1943
  },
  {
    title: "Bebop",
    composer: "Dizzy Gillespie",
    year: 1945,
    minor: true
  },
  {
    title: "Bebop Romp",
    composer: "Tadd Dameron",
    year: 1947
  },
  {
    title: "Begin the Beguine",
    composer: "Cole Porter",
    year: 1934,
    latin: true
  },
  {
    title: "Bemsha Swing",
    composer: "Thelonious Monk & Denzil Best",
    year: 1952
  },
  {
    title: "Bernie's Tune",
    composer: "Bernie Miller",
    year: 1953,
    minor: true
  },
  {
    title: "Bess, You Is My Woman Now",
    composer: "George Gershwin/Ira Gershwin & DuBose Heyward",
    year: 1934
  },
  {
    title: "Between the Devil and the Deep Blue Sea",
    composer: "Harold Arlen/Ted Koehler",
    year: 1931
  },
  {
    title: "Bewitched, Bothered, and Bewildered",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1940
  },
  {
    title: "Big Butter and Egg Man",
    composer: "Percy Venable",
    year: 1926
  },
  {
    title: "Big Foot",
    composer: "Charlie Parker",
    year: 1948,
    blues: true
  },
  {
    title: "Billie's Bounce",
    composer: "Charlie Parker",
    year: 1945,
    blues: true
  },
  {
    title: "Bird Feathers",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Bird Gets the Worm",
    composer: "Charlie Parker",
    year: 1947
  },
  {
    title: "Bird of Paradise",
    composer: "Charlie Parker",
    year: 1947,
    contrafact: true
  },
  {
    title: "Birdland Blues",
    composer: "Bud Powell",
    year: 1957,
    blues: true
  },
  {
    title: "Birks Works",
    composer: "Dizzy Gillespie",
    year: 1951,
    blues: true,
    minor: true
  },
  {
    title: "Bish Bash Bosh",
    composer: "Barry Harris",
    year: 1962
  },
  {
    title: "Bitty Ditty",
    composer: "Thad Jones",
    year: 1955
  },
  {
    title: "Black and Blue",
    composer: "Fats Waller/Andy Razaf & Harry Brooks",
    year: 1929
  },
  {
    title: "Black and Tan Fantasy",
    composer: "Duke Ellington & Bubber Miley",
    year: 1927,
    blues: true
  },
  {
    title: "Black Beauty",
    composer: "Duke Ellington",
    year: 1928
  },
  {
    title: "Black Codes",
    composer: "Wynton Marsalis",
    year: 1985
  },
  {
    title: "Black Narcissus",
    composer: "Joe Henderson",
    year: 1969,
    waltz: true,
    ballad: true
  },
  {
    title: "Bleecker Street Theme",
    composer: "Cedar Walton",
    year: 1973,
    blues: true
  },
  {
    title: "Blood Count",
    composer: "Billy Strayhorn",
    year: 1967,
    ballad: true
  },
  {
    title: "Bloomdido",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Blue 'n' Boogie",
    composer: "Dizzy Gillespie & Frank Paparelli",
    year: 1945,
    blues: true
  },
  {
    title: "Blue and Sentimental",
    composer: "Count Basie, Mack David, Jerry Livingston",
    year: 1938
  },
  {
    title: "Blue Bossa",
    composer: "Kenny Dorham",
    year: 1963,
    latin: true
  },
  {
    title: "Blue Daniel",
    composer: "Frank Rosolino",
    year: 1959,
    waltz: true
  },
  {
    title: "Blue in Green",
    composer: "Bill Evans, Miles Davis",
    year: 1959
  },
  {
    title: "Blue Lou",
    composer: "Edgar Sampson",
    year: 1935
  },
  {
    title: "Blue Monk",
    composer: "Thelonious Monk",
    year: 1954,
    blues: true
  },
  {
    title: "Blue Moon",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1934
  },
  {
    title: "Blue Pearl",
    composer: "Bud Powell",
    year: 1957
  },
  {
    title: "Blue Room",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1926
  },
  {
    title: "Blue Skies",
    composer: "Irving Berlin",
    year: 1926
  },
  {
    title: "Blue Spring",
    composer: "Kenny Dorham",
    year: 1959,
    blues: true
  },
  {
    title: "Bluebird",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Blues Again",
    composer: "Mulgrew Miller",
    year: 1986,
    blues: true
  },
  {
    title: "Blues By Five",
    composer: "Miles Davis",
    year: 1956,
    blues: true
  },
  {
    title: "Blues Five Spot",
    composer: "Thelonious Monk",
    year: 1958,
    blues: true
  },
  {
    title: "Blues for Alice",
    composer: "Charlie Parker",
    year: 1951,
    blues: true
  },
  {
    title: "Blues in the Night",
    composer: "Harold Arlen/Johnny Mercer",
    year: 1941,
    blues: true
  },
  {
    title: "Blues on Purpose",
    composer: "Rudy Stevenson",
    year: 1965,
    blues: true
  },
  {
    title: "Blues March",
    composer: "Benny Golson",
    year: 1958,
    blues: true
  },
  {
    title: "Bluesette",
    composer: "Toots Thielmans/Norman Gimbel",
    year: 1962,
    waltz: true
  },
  {
    title: "Body and Soul",
    composer: "Johnny Green/Edward Heyman, Robert Sour, Frank Eyton",
    year: 1930,
    ballad: true
  },
  {
    title: "Bolivia",
    composer: "Cedar Walton",
    year: 1975
  },
  {
    title: "Bongo Bop",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Boo Boo's Birthday",
    composer: "Thelonious Monk",
    year: 1967
  },
  {
    title: "Boperation",
    composer: "Tadd Dameron",
    year: 1948
  },
  {
    title: "Borderick",
    composer: "Bud Powell",
    year: 1958
  },
  {
    title: "Born to Be Blue",
    composer: "Mel Torme & Robert Wells",
    year: 1946
  },
  {
    title: "Bouncing with Bud",
    composer: "Bud Powell",
    year: 1946
  },
  {
    title: "Bourbon Street Parade",
    composer: "Paul Barbarin",
    year: 1955
  },
  {
    title: "Brake's Sake",
    composer: "Thelonious Monk",
    year: 1955
  },
  {
    title: "Bright Mississippi",
    composer: "Thelonious Monk",
    year: 1961,
    contrafact: true
  },
  {
    title: "Brilliant Corners",
    composer: "Thelonious Monk",
    year: 1956
  },
  {
    title: "Broadway",
    composer: "Wilbur H. Bird, Teddy McRae, Henri Woode",
    year: 1940
  },
  {
    title: "Bud's Blues",
    composer: "Sonny Stitt",
    year: 1949,
    blues: true
  },
  {
    title: "Buster Rides Again",
    composer: "Bud Powell",
    year: 1958
  },
  {
    title: "But Beautiful",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1947,
    ballad: true
  },
  {
    title: "But Not For Me",
    composer: "George Gershwin/Ira Gershwin",
    year: 1930
  },
  {
    title: "Buzzy",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "By Myself",
    composer: "Arthur Schwartz/Howard Dietz",
    year: 1937
  },
  {
    title: "Bye Bye Blackbird",
    composer: "Ray Henderson/Mort Dixon",
    year: 1926,
    miles: true
  },
  {
    title: "Bye-Ya",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "C Jam Blues (Duke's Place)",
    composer: "Duke Ellington",
    year: 1940,
    blues: true
  },
  {
    title: "C.T.A.",
    composer: "Jimmy Heath",
    year: 1959,
    rhythm: true
  },
  {
    title: "Calcutta Cutie",
    composer: "Horace Silver",
    year: 1963
  },
  {
    title: "Can't Get Out of This Mood",
    composer: "Jimmy McHugh/Frank Loesser",
    year: 1942
  },
  {
    title: "Can't Help Lovin' Dat Man",
    composer: "Jerome Kern/Oscar Hammerstein II",
    year: 1927
  },
  {
    title: "Canadian Sunset",
    composer: "Eddie Heywood/Norman Gimbel",
    year: 1956
  },
  {
    title: "Cantaloupe Island",
    composer: "Herbie Hancock",
    year: 1964
  },
  {
    title: "Caravan",
    composer: "Juan Tizol/Irving Mills",
    year: 1936,
    latin: true
  },
  {
    title: "Cardboard",
    composer: "Charlie Parker",
    year: 1949
  },
  {
    title: "Carioca",
    composer: "Vincent Youmans/Edward Eliscu & Gus Kahn",
    year: 1933,
    latin: true
  },
  {
    title: "Carol of the Bells",
    composer: "Mykola Leontovych/Peter J. Wilhousky",
    year: 1904,
    holiday: true
  },
  {
    title: "Carolina Moon",
    composer: "Joe Burke & Benny Davis",
    year: 1924
  },
  {
    title: "Carolina Shout",
    composer: "James P. Johnson",
    year: 1921
  },
  {
    title: "Casbah",
    composer: "Tadd Dameron",
    year: 1949,
    contrafact: true
  },
  {
    title: "Carvin' the Bird",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Celia",
    composer: "Bud Powell",
    year: 1949
  },
  {
    title: "Central Park West",
    composer: "John Coltrane",
    year: 1960,
    ballad: true
  },
  {
    title: "Ceora",
    composer: "Lee Morgan",
    year: 1965,
    latin: true
  },
  {
    title: "Change Partners",
    composer: "Irving Berlin",
    year: 1938
  },
  {
    title: "Charlie's Wig",
    composer: "Charlie Parker",
    year: 1947
  },
  {
    title: "Chasin' the Bird",
    composer: "Charlie Parker",
    year: 1947,
    rhythm: true
  },
  {
    title: "Cheek To Cheek",
    composer: "Irving Berlin",
    year: 1935
  },
  {
    title: "Cheers",
    composer: "Charlie Parker",
    year: 1947,
    rhythm: true
  },
  {
    title: "Chega de Saudade (No More Blues)",
    composer: "Antonio Carlos Jobim",
    year: 1958,
    latin: true
  },
  {
    title: "Chelsea Bridge",
    composer: "Billy Strayhorn",
    year: 1941,
    ballad: true
  },
  {
    title: "Cherokee",
    composer: "Ray Noble",
    year: 1938
  },
  {
    title: "Cheryl",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Chi-Chi",
    composer: "Charlie Parker",
    year: 1953,
    blues: true
  },
  {
    title: "Christmas Time is Here",
    composer: "Vince Guaraldi/Lee Mendelson",
    year: 1965,
    waltz: true,
    ballad: true,
    holiday: true
  },
  {
    title: "Cleopatra's Dream",
    composer: "Bud Powell",
    year: 1958
  },
  {
    title: "Clockwise",
    composer: "Cedar Walton",
    year: 1977,
    waltz: true
  },
  {
    title: "Close Your Eyes",
    composer: "Bernice Petkere",
    year: 1933
  },
  {
    title: "Cocktails for Two",
    composer: "Arthur Johnston/Sam Coslow",
    year: 1934
  },
  {
    title: "Coffee Pot",
    composer: "J.J. Johnson",
    year: 1954,
    contrafact: true
  },
  {
    title: "Collard Greens and Black-Eyed Peas (Blues in the Closet)",
    composer: "Oscar Pettiford",
    year: 1953,
    blues: true
  },
  {
    title: "Come Rain Or Come Shine",
    composer: "Harold Arlen/Johnny Mercer",
    year: 1946
  },
  {
    title: "Come Sunday",
    composer: "Duke Ellington",
    year: 1943,
    ballad: true
  },
  {
    title: "Coming on the Hudson",
    composer: "Thelonious Monk",
    year: 1958
  },
  {
    title: "Compulsion",
    composer: "Miles Davis",
    year: 1953,
    rhythm: true
  },
  {
    title: "Con Alma",
    composer: "Dizzy Gillespie",
    year: 1954,
    latin: true,
    ballad: true
  },
  {
    title: "Conception",
    composer: "George Shearing",
    year: 1950
  },
  {
    title: "Confirmation",
    composer: "Charlie Parker",
    year: 1953
  },
  {
    title: "Constellation",
    composer: "Charlie Parker",
    year: 1948,
    rhythm: true
  },
  {
    title: "Cool Blues",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Coquette",
    composer: "Johnny Green & Carmen Lombardo/Gus Kahn",
    year: 1928
  },
  {
    title: "Corcovado (Quiet Nights of Quiet Stars)",
    composer: "Antonio Carlos Jobim",
    year: 1962,
    latin: true
  },
  {
    title: "Coscrane",
    composer: "Bud Powell",
    year: 1956,
    blues: true
  },
  {
    title: "Cosmic Rays",
    composer: "Charlie Parker",
    year: 1952,
    blues: true
  },
  {
    title: "Cotton Tail",
    composer: "Duke Ellington",
    year: 1940,
    rhythm: true
  },
  {
    title: "Count Your Blessings (Instead of Sheep)",
    composer: "Irving Berlin",
    year: 1954
  },
  {
    title: "Crazeology (Bud's Bubble)",
    composer: "Charlie Parker",
    year: 1947,
    rhythm: true
  },
  {
    title: "Crazy He Calls Me",
    composer: "Carl Sigman/Bob Russell",
    year: 1949,
    ballad: true
  },
  {
    title: "Crazy Rhythm",
    composer: "Irving Caesar, Joseph Meyer, Roger Wolfe Kahn",
    year: 1928
  },
  {
    title: "Crepuscule with Nellie",
    composer: "Thelonious Monk",
    year: 1957,
    ballad: true
  },
  {
    title: "Criss Cross",
    composer: "Thelonious Monk",
    year: 1951
  },
  {
    title: "Crossin' the Channel",
    composer: "Bud Powell",
    year: 1958
  },
  {
    title: "Daahoud",
    composer: "Clifford Brown",
    year: 1955
  },
  {
    title: "Dameronia",
    composer: "Tadd Dameron",
    year: 1947
  },
  {
    title: "Dance Cadaverous",
    composer: "Wayne Shorter",
    year: 1965,
    waltz: true
  },
  {
    title: "Dance of the Infidels",
    composer: "Bud Powell",
    year: 1949,
    blues: true
  },
  {
    title: "Danceland",
    composer: "Bud Powell",
    year: 1958
  },
  {
    title: "Dancing in the Dark",
    composer: "Arthur Schwartz/Howard Dietz",
    year: 1931
  },
  {
    title: "Dancing on the Ceiling",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1930
  },
  {
    title: "Dark Eyes",
    composer: "Adalgiso Ferraris",
    year: 1910,
    minor: true
  },
  {
    title: "Darn That Dream",
    composer: "Jimmy Van Heusen/Eddie De Lange",
    year: 1939,
    ballad: true
  },
  {
    title: "Day By Day",
    composer: "Alex Stordahl & Paul Weston/Sammy Cahn",
    year: 1945
  },
  {
    title: "Day Dream",
    composer: "Billy Strayhorn & Duke Ellington/John La Touche",
    year: 1941,
    ballad: true
  },
  {
    title: "Day In, Day Out",
    composer: "Rube Bloom/Johnny Mercer",
    year: 1939
  },
  {
    title: "Days of Wine and Roses",
    composer: "Henry Mancini/Johnny Mercer",
    year: 1962
  },
  {
    title: "Dear Old Stockholm",
    composer: "Swedish folk song",
    year: 1846,
    miles: true
  },
  {
    title: "Dearly Beloved",
    composer: "Jerome Kern/Johnny Mercer",
    year: 1942
  },
  {
    title: "Deed I Do",
    composer: "Fred Rose/Walter Hirsch",
    year: 1926
  },
  {
    title: "Deep in a Dream",
    composer: "Jimmy Van Heusen/Eddie De Lange",
    year: 1938,
    ballad: true
  },
  {
    title: "Deep Night",
    composer: "Charles E. Henderson/Rudy Vallee",
    year: 1929
  },
  {
    title: "Delfeayo's Dilemma",
    composer: "Wynton Marsalis",
    year: 1985
  },
  {
    title: "Desafinado",
    composer: "Antonio Carlos Jobim",
    year: 1959,
    latin: true
  },
  {
    title: "Dewey Square",
    composer: "Charlie Parker",
    year: 1947
  },
  {
    title: "Dexterity",
    composer: "Charlie Parker",
    year: 1945,
    rhythm: true
  },
  {
    title: "Diane",
    composer: "Lew Pollack & Ernö Rapée",
    year: 1927,
    miles: true
  },
  {
    title: "Diggin' Diz",
    composer: "Dizzy Gillespie",
    year: 1946
  },
  {
    title: "Dinah",
    composer: "Harry Akst/Sam M. Lewis & Joseph Young",
    year: 1925
  },
  {
    title: "Dindi",
    composer: "Antonio Carlos Jobim",
    year: 1965,
    latin: true
  },
  {
    title: "Dizzy Atmosphere",
    composer: "Dizzy Gillespie",
    year: 1945,
    rhythm: true
  },
  {
    title: "Django",
    composer: "John Lewis",
    year: 1954
  },
  {
    title: "Do I Love You?",
    composer: "Cole Porter",
    year: 1939
  },
  {
    title: "Do Nothing till You Hear from Me (Concerto for Cootie)",
    composer: "Duke Ellington",
    year: 1940
  },
  {
    title: "Do You Know What It Means To Miss New Orleans",
    composer: "Louis Alter/Eddie De Lange",
    year: 1946,
    ballad: true
  },
  {
    title: "Dolphin Dance",
    composer: "Herbie Hancock",
    year: 1965
  },
  {
    title: "Don't Blame Me",
    composer: "Jimmy McHugh/Dorothy Fields",
    year: 1932
  },
  {
    title: "Don't Explain",
    composer: "Billie Holiday/Arthur Herzog, Jr.",
    year: 1944
  },
  {
    title: "Don't Get Around Much Anymore (Never No Lament)",
    composer: "Duke Ellington/Bob Russell",
    year: 1940
  },
  {
    title: "Don't Mention Love to Me",
    composer: "Oscar Levant/Dorothy Fields",
    year: 1935
  },
  {
    title: "Don't Worry About Me",
    composer: "Rube Bloom/Ted Koehler",
    year: 1939
  },
  {
    title: "Donna Lee",
    composer: "Miles Davis",
    year: 1947,
    contrafact: true
  },
  {
    title: "Double Talk",
    composer: "Tadd Dameron",
    year: 1948
  },
  {
    title: "Down With It",
    composer: "Bud Powell",
    year: 1958
  },
  {
    title: "Doxy",
    composer: "Sonny Rollins",
    year: 1954
  },
  {
    title: "Dream a Little Dream of Me",
    composer: "Fabian Andre & Wilbur Schwandt/Gus Kahn",
    year: 1931
  },
  {
    title: "Drifting on a Reed",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Drop Me Off in Harlem",
    composer: "Duke Ellington/Nick Kenny",
    year: 1933
  },
  {
    title: "Dry Soul",
    composer: "Bud Powell",
    year: 1958,
    blues: true
  },
  {
    title: "Duid Deed",
    composer: "Bud Powell",
    year: 1958
  },
  {
    title: "Dusk in Sandi",
    composer: "Bud Powell",
    year: 1951
  },
  {
    title: "E.S.P.",
    composer: "Wayne Shorter",
    year: 1965
  },
  {
    title: "East of the Sun (and West of the Moon)",
    composer: "Brooks Bowman",
    year: 1934
  },
  {
    title: "Easy Living",
    composer: "Ralph Rainger/Leo Robin",
    year: 1937,
    ballad: true
  },
  {
    title: "Easy Street",
    composer: "Alan Rankin Jones",
    year: 1941
  },
  {
    title: "Easy to Love",
    composer: "Cole Porter",
    year: 1934
  },
  {
    title: "Easy Walker",
    composer: "Billy Taylor",
    year: 1959
  },
  {
    title: "Eclypso",
    composer: "Tommy Flanagan",
    year: 1957,
    latin: true
  },
  {
    title: "Emanon",
    composer: "Dizzy Gillespie",
    year: 1945,
    blues: true
  },
  {
    title: "Embraceable You",
    composer: "George Gershwin/Ira Gershwin",
    year: 1930,
    ballad: true
  },
  {
    title: "Emily",
    composer: "Johnny Mandel/Johnny Mercer",
    year: 1964,
    waltz: true
  },
  {
    title: "Empty Pockets",
    composer: "Herbie Hancock",
    year: 1962,
    blues: true
  },
  {
    title: "Epistrophy",
    composer: "Thelonious Monk/Kenny Clarke",
    year: 1941
  },
  {
    title: "Eronel",
    composer: "Thelonious Monk, Sadik Hakim, Idrees Sulieman",
    year: 1951
  },
  {
    title: "Ev'ry Time We Say Goodbye",
    composer: "Cole Porter",
    year: 1944,
    ballad: true
  },
  {
    title: "Ev'rything I Love",
    composer: "Cole Porter",
    year: 1941
  },
  {
    title: "Ev'rything I've Got",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1942
  },
  {
    title: "Everything Happens to Me",
    composer: "Matt Dennis/Tom Adair",
    year: 1941,
    ballad: true
  },
  {
    title: "Everything I Have Is Yours",
    composer: "Burton Lane/Harold Adamson",
    year: 1933
  },
  {
    title: "Evidence",
    composer: "Thelonious Monk",
    year: 1948,
    contrafact: true
  },
  {
    title: "Evonce",
    composer: "Thelonious Monk",
    year: 1947
  },
  {
    title: "Exactly Like You",
    composer: "Jimmy McHugh/Dorothy Fields",
    year: 1930
  },
  {
    title: "Falling in Love with Love",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1938
  },
  {
    title: "Fascinating Rhythm",
    composer: "George Gershwin/Ira Gershwin",
    year: 1924
  },
  {
    title: "Fats Blows",
    composer: "Tadd Dameron",
    year: 1947,
    contrafact: true
  },
  {
    title: "Feliz Navidad",
    composer: "Jose Feliciano",
    year: 1970,
    holiday: true
  },
  {
    title: "Fine and Dandy",
    composer: "Kay Swift/Paul James",
    year: 1930
  },
  {
    title: "Fine and Mellow",
    composer: "Billie Holiday",
    year: 1940,
    blues: true
  },
  {
    title: "Fingers",
    composer: "Thad Jones",
    year: 1970,
    rhythm: true
  },
  {
    title: "Firm Roots",
    composer: "Cedar Walton",
    year: 1974
  },
  {
    title: "First Trip",
    composer: "Ron Carter",
    year: 1968
  },
  {
    title: "Five Spot After Dark",
    composer: "Benny Golson",
    year: 1959
  },
  {
    title: "Flamenco Sketches",
    composer: "Miles Davis, Bill Evans",
    year: 1959
  },
  {
    title: "Flamingo",
    composer: "Ted Grouya & Edmund Anderson",
    year: 1940,
    latin: true
  },
  {
    title: "Fleurette Africaine (African Flower)",
    composer: "Duke Ellington",
    year: 1952,
    ballad: true
  },
  {
    title: "Flossie Lou",
    composer: "Tadd Dameron",
    year: 1956
  },
  {
    title: "Fly Me to the Moon (In Other Words)",
    composer: "Bart Howard",
    year: 1954,
    sinatra: true
  },
  {
    title: "Flying Down to Rio",
    composer: "Vincent Youmans/Edward Eliscu & Gus Kahn",
    year: 1933
  },
  {
    title: "Fontainebleau",
    composer: "Tadd Dameron",
    year: 1956
  },
  {
    title: "Fools Rush In (Where Angels Fear to Tread)",
    composer: "Rube Bloom/Johnny Mercer",
    year: 1940
  },
  {
    title: "For All We Know",
    composer: "J. Fred Coots",
    year: 1934,
    ballad: true
  },
  {
    title: "For Heaven's Sake",
    composer: "Elise Bretton/Donald Meyer & Sherman Edwards",
    year: 1946,
    ballad: true
  },
  {
    title: "For Wee Folks",
    composer: "Wynton Marsalis",
    year: 1985,
    ballad: true
  },
  {
    title: "For You, For Me, For Evermore",
    composer: "George Gershwin/Ira Gershwin",
    year: 1937
  },
  {
    title: "Four",
    composer: "Miles Davis",
    year: 1954
  },
  {
    title: "Four in One",
    composer: "Thelonious Monk",
    year: 1951
  },
  {
    title: "Freddie Freeloader",
    composer: "Miles Davis",
    year: 1959,
    blues: true
  },
  {
    title: "Frenesi",
    composer: "Alberto Dominguez/Bob Russell & Ray Charles",
    year: 1940,
    latin: true
  },
  {
    title: "Friday the 13th",
    composer: "Thelonious Monk",
    year: 1953
  },
  {
    title: "From This Moment On",
    composer: "Cole Porter",
    year: 1951
  },
  {
    title: "Frosty the Snowman",
    composer: "Walter Rollins & Steve Nelson",
    year: 1950,
    holiday: true
  },
  {
    title: "Functional",
    composer: "Thelonious Monk",
    year: 1957,
    blues: true
  },
  {
    title: "Gallop's Gallop",
    composer: "Thelonious Monk",
    year: 1955
  },
  {
    title: "Gee Baby, Ain't I Good to You",
    composer: "Don Redman/Andy Razaf",
    year: 1929
  },
  {
    title: "Georgia on My Mind",
    composer: "Hoagy Carmichael/Stuart Gorrell",
    year: 1930
  },
  {
    title: "Get Happy",
    composer: "Harold Arlen/Ted Koehler",
    year: 1930
  },
  {
    title: "Get Out of Town",
    composer: "Cole Porter",
    year: 1938
  },
  {
    title: "Gettin' There",
    composer: "Bud Powell",
    year: 1958
  },
  {
    title: "Giant Steps",
    composer: "John Coltrane",
    year: 1959
  },
  {
    title: "Girl Talk",
    composer: "Neal Hefti/Bobby Troup",
    year: 1965
  },
  {
    title: "Give Me the Simple Life",
    composer: "Rube Bloom/Harry Ruby",
    year: 1945
  },
  {
    title: "Glad to Be Unhappy",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1936,
    ballad: true
  },
  {
    title: "Glass Enclosure",
    composer: "Bud Powell",
    year: 1953
  },
  {
    title: "Gnid",
    composer: "Tadd Dameron",
    year: 1956
  },
  {
    title: "Go Tell It on the Mountain",
    composer: "John Wesley Work, Jr.",
    year: 1865,
    holiday: true
  },
  {
    title: "God Bless the Child",
    composer: "Billie Holiday & Arthur Herzog, Jr.",
    year: 1939
  },
  {
    title: "Gone with the Wind",
    composer: "Allie Wrubel/Herb Magidson",
    year: 1937
  },
  {
    title: "Good Bait",
    composer: "Tadd Dameron & Count Basie",
    year: 1944,
    rhythm: true
  },
  {
    title: "Good Morning Heartache",
    composer: "Ervin Drake, Dan Fisher, Irene Higgenbotham",
    year: 1945,
    ballad: true
  },
  {
    title: "Goodbye",
    composer: "Gordon Jenkins",
    year: 1935,
    ballad: true
  },
  {
    title: "Goodbye to Childhood",
    composer: "Herbie Hancock",
    year: 1968
  },
  {
    title: "Grand Central",
    composer: "John Coltrane",
    year: 1959
  },
  {
    title: "Green Chimneys",
    composer: "Thelonious Monk",
    year: 1966
  },
  {
    title: "Groovin' High",
    composer: "Dizzy Gillespie",
    year: 1945
  },
  {
    title: "Groundwork",
    composer: "Cedar Walton",
    year: 1983
  },
  {
    title: "Guess I'll Hang My Tears Out To Dry",
    composer: "Jule Styne/Sammy Cahn",
    year: 1945,
    ballad: true
  },
  {
    title: "Hackensack",
    composer: "Thelonious Monk",
    year: 1954,
    contrafact: true
  },
  {
    title: "Half Nelson",
    composer: "Miles Davis",
    year: 1947,
    contrafact: true
  },
  {
    title: "Hallelujah",
    composer: "Vincent Youmans/Clifford Grey & Leo Robin",
    year: 1927,
    rhythm: true
  },
  {
    title: "Hallucinations (Budo)",
    composer: "Bud Powell",
    year: 1951
  },
  {
    title: "Happiness is a Thing Called Joe",
    composer: "Harold Arlen/Yip Harburg",
    year: 1943
  },
  {
    title: "Happy Holiday",
    composer: "Irving Berlin",
    year: 1941,
    holiday: true
  },
  {
    title: "Happy Talk",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1949
  },
  {
    title: "Haunted Heart",
    composer: "Arthur Schwartz/Howard Dietz",
    year: 1948
  },
  {
    title: "Have You Met Miss Jones?",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1937
  },
  {
    title: "Have Yourself a Merry Little Christmas",
    composer: "Hugh Martin/Ralph Blane",
    year: 1943,
    holiday: true
  },
  {
    title: "Head and Shoulders",
    composer: "Cedar Walton",
    year: 1967
  },
  {
    title: "Heart and Soul",
    composer: "Hoagy Carmichael/Frank Loesser",
    year: 1938
  },
  {
    title: "Heartaches",
    composer: "Al Hoffman/John Klenner",
    year: 1931
  },
  {
    title: "Heat Wave",
    composer: "Irving Berlin",
    year: 1933
  },
  {
    title: "Hello, Young Lovers",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1951
  },
  {
    title: "Here Comes Santa Claus",
    composer: "Gene Autrey/Oakley Haldeman",
    year: 1947,
    holiday: true
  },
  {
    title: "Here I'll Stay",
    composer: "Kurt Weill/Alan Jay Lerner",
    year: 1948
  },
  {
    title: "Here's That Rainy Day",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1953
  },
  {
    title: "Here's to My Lady",
    composer: "Rube Bloom/Johnny Mercer",
    year: 1952
  },
  {
    title: "Hindsight",
    composer: "Cedar Walton",
    year: 1996
  },
  {
    title: "Holy Land",
    composer: "Cedar Walton",
    year: 1967
  },
  {
    title: "Honeysuckle Rose",
    composer: "Fats Waller/Andy Razaf",
    year: 1929
  },
  {
    title: "Hornin' In",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "Hot House",
    composer: "Tadd Dameron",
    year: 1945
  },
  {
    title: "How About You?",
    composer: "Burton Lane/Ralph Freed",
    year: 1941
  },
  {
    title: "How Am I to Know?",
    composer: "Jack King/Dorothy Parker",
    year: 1929
  },
  {
    title: "How Are Things in Glocca Morra?",
    composer: "Burton Lane/Yip Harburg",
    year: 1946
  },
  {
    title: "How Deep is the Ocean",
    composer: "Irving Berlin",
    year: 1932
  },
  {
    title: "How High the Moon",
    composer: "Morgan Lewis/Nancy Hamilton",
    year: 1940
  },
  {
    title: "How Insensitive",
    composer: "Antonio Carlos Jobim",
    year: 1963,
    latin: true
  },
  {
    title: "How Little We Know",
    composer: "Hoagy Carmichael/Johnny Mercer",
    year: 1944
  },
  {
    title: "How Long Has This Been Going On?",
    composer: "George Gershwin/Ira Gershwin",
    year: 1928
  },
  {
    title: "How My Heart Sings!",
    composer: "Earl Zindars",
    year: 1962,
    waltz: true
  },
  {
    title: "Humph",
    composer: "Thelonious Monk",
    year: 1947,
    rhythm: true
  },
  {
    title: "I Ain't Got Nobody",
    composer: "Spencer Williams/Roger A. Graham",
    year: 1915
  },
  {
    title: "I Can't Believe That You're in Love with Me",
    composer: "Jimmy McHugh/Clarence Gaskill",
    year: 1926
  },
  {
    title: "I Can't Get Started (with You)",
    composer: "Vernon Duke/Ira Gershwin",
    year: 1935,
    ballad: true
  },
  {
    title: "I Can't Give You Anything But Love",
    composer: "Jimmy McHugh/Dorothy Fields",
    year: 1928
  },
  {
    title: "I Concentrate On You",
    composer: "Cole Porter",
    year: 1940
  },
  {
    title: "I Could Have Danced All Night",
    composer: "Frederick Loewe/Alan Jay Lerner",
    year: 1956
  },
  {
    title: "I Could Write a Book",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1940,
    miles: true
  },
  {
    title: "I Cover the Waterfront",
    composer: "Johnny Green/Edward Heyman",
    year: 1933
  },
  {
    title: "I Cried for You",
    composer: "Gus Arnheim, Arthur Freed, Abe Lyman",
    year: 1923
  },
  {
    title: "I Didn't Know About You",
    composer: "Duke Ellington/Bob Russell",
    year: 1944,
    ballad: true
  },
  {
    title: "I Didn't Know What Time It Was",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1939
  },
  {
    title: "I Don't Stand a Ghost of a Chance With You",
    composer: "Victor Young/Ned Washington & Bing Crosby",
    year: 1932
  },
  {
    title: "I Fall in Love Too Easily",
    composer: "Jule Stein/Sammy Cahn",
    year: 1944,
    miles: true,
    ballad: true
  },
  {
    title: "I Get a Kick out of You",
    composer: "Cole Porter",
    year: 1934,
    sinatra: true
  },
  {
    title: "I Get Along Without You Very Well (Except Sometimes)",
    composer: "Hoagy Carmichael/Jane Brown Thompson",
    year: 1938,
    ballad: true
  },
  {
    title: "I Got Plenty o' Nuttin'",
    composer: "George Gershwin/Ira Gershwin & DuBose Heyward",
    year: 1934
  },
  {
    title: "I Got It Bad (And That Ain't Good)",
    composer: "Duke Ellington/Paul Francis Webster",
    year: 1941,
    ballad: true
  },
  {
    title: "I Got Rhythm",
    composer: "George Gershwin/Ira Gershwin",
    year: 1930,
    rhythm: true
  },
  {
    title: "I Gotta Right to Sing the Blues",
    composer: "Harold Arlen/Ted Koehler",
    year: 1932
  },
  {
    title: "I Guess I'll Have to Change My Plan",
    composer: "Arthur Schwartz/Howard Dietz",
    year: 1929
  },
  {
    title: "I Had the Craziest Dream",
    composer: "Harry Warren/Mack Gordon",
    year: 1943
  },
  {
    title: "I Hadn't Anyone Till You",
    composer: "Ray Noble",
    year: 1938
  },
  {
    title: "I Have Dreamed",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1951
  },
  {
    title: "I Hear a Rhapsody",
    composer: "George Fragos, Jack Baker, Dick Gasparre",
    year: 1940
  },
  {
    title: "I Hear Music",
    composer: "Burton Lane/Frank Loesser",
    year: 1940
  },
  {
    title: "I Know That You Know",
    composer: "Vincent Youmans/Anne Caldwell",
    year: 1926
  },
  {
    title: "I Let a Song Go Out of My Heart",
    composer: "Duke Ellington/Irving Mills, Henry Nemo & John Redmond",
    year: 1938
  },
  {
    title: "I Like to Recognize the Tune",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1939
  },
  {
    title: "I Love Paris",
    composer: "Cole Porter",
    year: 1953
  },
  {
    title: "I Love You",
    composer: "Cole Porter",
    year: 1944
  },
  {
    title: "I Love You, Sweetheart of All My Dreams",
    composer: "Art Fitch, Kay Fitch, Bert Lowe",
    year: 1926
  },
  {
    title: "I Loves You, Porgy",
    composer: "George Gershwin/Ira Gershwin & DuBose Heyward",
    year: 1934,
    ballad: true
  },
  {
    title: "I May Be Wrong (But I Think You're Wonderful)",
    composer: "Henry Sullivan/Harry Ruskin",
    year: 1929
  },
  {
    title: "I Mean You",
    composer: "Thelonious Monk",
    year: 1946
  },
  {
    title: "I Must Have That Man",
    composer: "Jimmy McHugh/Dorothy Fields",
    year: 1928
  },
  {
    title: "I Never Knew",
    composer: "Ted Fio Rito/Gus Kahn",
    year: 1925
  },
  {
    title: "I Only Have Eyes for You",
    composer: "Harry Warren/Al Dubin",
    year: 1934
  },
  {
    title: "I Remember Clifford",
    composer: "Benny Golson",
    year: 1957
  },
  {
    title: "I Remember You",
    composer: "Victor Schertzinger/Johnny Mercer",
    year: 1942
  },
  {
    title: "I Saw Mommy Kissing Santa Claus",
    composer: "Tommie Connor",
    year: 1952,
    holiday: true
  },
  {
    title: "I See Your Face Before Me",
    composer: "Arthur Schwartz/Howard Dietz",
    year: 1937
  },
  {
    title: "I Should Care",
    composer: "Alex Stordahl & Paul Weston/Sammy Cahn",
    year: 1944
  },
  {
    title: "I Surrender Dear",
    composer: "Harry Barris/Gordon Clifford",
    year: 1931
  },
  {
    title: "I Thought About You",
    composer: "Jimmy Van Heusen/Johnny Mercer",
    year: 1939,
    miles: true,
    ballad: true
  },
  {
    title: "I Want to Be Happy",
    composer: "Vincent Youmans/Irving Caesar",
    year: 1924
  },
  {
    title: "I Want to Talk About You",
    composer: "Billy Eckstine",
    year: 1944,
    ballad: true
  },
  {
    title: "I Was Doing All Right",
    composer: "George Gershwin/Ira Gershwin",
    year: 1937
  },
  {
    title: "I Wish I Knew",
    composer: "Harry Warren/Mack Gordon",
    year: 1945
  },
  {
    title: "I Wish You Love",
    composer: "Charles Louis Trenet/Albert Askew Beach",
    year: 1946,
    sinatra: true
  },
  {
    title: "I Wished on the Moon",
    composer: "Ralph Rainger/Dorothy Parker",
    year: 1935
  },
  {
    title: "I Won't Dance",
    composer: "Jerome Kern/Dorothy Fields",
    year: 1934
  },
  {
    title: "I'll Be Around",
    composer: "Alec Wilder",
    year: 1942,
    ballad: true
  },
  {
    title: "I'll Be Home for Christmas",
    composer: "Walter Kent/Kim Gannon",
    year: 1943,
    holiday: true
  },
  {
    title: "I'll Be Seeing You",
    composer: "Sammy Fain/Irving Kahal",
    year: 1938,
    sinatra: true
  },
  {
    title: "I'll Follow You",
    composer: "Fred E. Ahlert/Roy Turk",
    year: 1932
  },
  {
    title: "I'll Keep Loving You",
    composer: "Bud Powell",
    year: 1949,
    ballad: true
  },
  {
    title: "I'll Never Be the Same",
    composer: "Matt Malneck & Frank Signorelli/Gus Kahn",
    year: 1932
  },
  {
    title: "I'll Remember April",
    composer: "Gene De Paul/Don Raye & Patricia Johnston",
    year: 1941
  },
  {
    title: "I'll See You in My Dreams",
    composer: "Isham Jones/Gus Kahn",
    year: 1924
  },
  {
    title: "I'll Take Romance",
    composer: "Ben Oakland/Oscar Hammerstein II",
    year: 1937
  },
  {
    title: "I'll Walk Alone",
    composer: "Jule Styne/Sammy Cahn",
    year: 1944
  },
  {
    title: "I'm a Fool to Want You",
    composer: "Joel S. Herron, Frank Sinatra, Jack Wolf",
    year: 1951,
    ballad: true
  },
  {
    title: "I'm Always Chasing Rainbows",
    composer: "Henry Carroll/Joseph McCarthy",
    year: 1917
  },
  {
    title: "I'm an Old Cowhand",
    composer: "Johnny Mercer",
    year: 1936
  },
  {
    title: "I'm Beginning to See the Light",
    composer: "Duke Ellington & Johnny Hodges",
    year: 1944
  },
  {
    title: "I'm Confessin' That I Love You",
    composer: "Ellis Reynolds, Doc Daugherty/Al J. Neiburg",
    year: 1930
  },
  {
    title: "I'm Getting Sentimental Over You",
    composer: "George Bassman/Ned Washington",
    year: 1933
  },
  {
    title: "I'm Gonna Sit Right Down and Write Myself a Letter",
    composer: "Fred E. Ahlert/Joe Young",
    year: 1935
  },
  {
    title: "I'm in the Mood for Love",
    composer: "Jimmy McHugh/Dorothy Fields",
    year: 1935
  },
  {
    title: "I'm Just a Lucky So-and-So",
    composer: "Duke Ellington/Mack David",
    year: 1945
  },
  {
    title: "I'm Old Fashioned",
    composer: "Jerome Kern/Johnny Mercer",
    year: 1942
  },
  {
    title: "I'm Through With Love",
    composer: "Fud Livingston & Matty Malneck/Gus Kahn",
    year: 1931
  },
  {
    title: "I've Found a New Baby",
    composer: "Jack Palmer & Spencer Williams",
    year: 1926
  },
  {
    title: "I've Got a Crush on You",
    composer: "George Gershwin/Ira Gershwin",
    year: 1928
  },
  {
    title: "I've Got a Feeling I'm Falling",
    composer: "Fats Waller",
    year: 1929
  },
  {
    title: "I've Got My Love to Keep Me Warm",
    composer: "Irving Berlin",
    year: 1937,
    holiday: true
  },
  {
    title: "I've Got the World On a String",
    composer: "Harold Arlen/Ted Koehler",
    year: 1932,
    sinatra: true
  },
  {
    title: "I've Got You Under My Skin",
    composer: "Cole Porter",
    year: 1936,
    sinatra: true
  },
  {
    title: "I've Grown Accustomed to Her Face",
    composer: "Frederick Loewe/Alan Jay Lerner",
    year: 1956,
    ballad: true
  },
  {
    title: "I've Heard That Song Before",
    composer: "Jule Styne/Sammy Cahn",
    year: 1942
  },
  {
    title: "I've Told Ev'ry Little Star",
    composer: "Jerome Kern/Oscar Hammerstein II",
    year: 1932
  },
  {
    title: "Idaho",
    composer: "Jesse A. Stone",
    year: 1942
  },
  {
    title: "If Ever I Would Leave You",
    composer: "Frederick Loewe/Alan Jay Lerner",
    year: 1960
  },
  {
    title: "If I Could Be with You (One Hour Tonight)",
    composer: "James P. Johnson/Henry Creamer",
    year: 1926
  },
  {
    title: "If I Had You",
    composer: "James Campbell, Reginald Connelly, Ted Shapiro",
    year: 1928
  },
  {
    title: "If I Love Again",
    composer: "Ben Oakland/Jack Murray",
    year: 1933
  },
  {
    title: "If I Only Had A Brain",
    composer: "Harold Arlen/Yip Harburg",
    year: 1939
  },
  {
    title: "If I Should Lose You",
    composer: "Ralph Rainger/Leo Robin",
    year: 1935
  },
  {
    title: "If I Were a Bell",
    composer: "Frank Loesser",
    year: 1950,
    miles: true
  },
  {
    title: "If There Is Someone Lovelier Than You",
    composer: "Arthur Schwartz/Howard Dietz",
    year: 1934
  },
  {
    title: "If This Isn't Love",
    composer: "Burton Lane/Yip Harburg",
    year: 1946
  },
  {
    title: "If You Could See Me Now",
    composer: "Tadd Dameron/Carl Sigman",
    year: 1946,
    ballad: true
  },
  {
    title: "If You Never Come to Me",
    composer: "Antonio Carlos Jobim/Vincius De Morales & Ray Gilbert",
    year: 1963,
    latin: true
  },
  {
    title: "Ill Wind (You're Blowin' Me No Good)",
    composer: "Harold Arlen/Ted Koehler",
    year: 1934
  },
  {
    title: "Imagination",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1940,
    ballad: true
  },
  {
    title: "Impressions",
    composer: "John Coltrane",
    year: 1961
  },
  {
    title: "In a Mellow Tone",
    composer: "Duke Ellington/Milt Gabler",
    year: 1939
  },
  {
    title: "In a Sentimental Mood",
    composer: "Duke Ellington/Manny Kurtz",
    year: 1939,
    ballad: true
  },
  {
    title: "In the Blue of the Evening",
    composer: "Al D'Artega/Tom Adair",
    year: 1943
  },
  {
    title: "In the Chapel in the Moonlight",
    composer: "Billy Hill",
    year: 1936,
    ballad: true
  },
  {
    title: "In the Land of Oo-Bla-Dee",
    composer: "Mary Lou Williams",
    year: 1945,
    blues: true
  },
  {
    title: "In the Still of the Night",
    composer: "Cole Porter",
    year: 1937
  },
  {
    title: "In the Wee Small Hours of the Morning",
    composer: "David A. Mann/Bob Hilliard",
    year: 1955,
    ballad: true
  },
  {
    title: "In Walked Bud",
    composer: "Thelonious Monk",
    year: 1947,
    contrafact: true
  },
  {
    title: "In Your Own Sweet Way",
    composer: "Dave Brubeck/Iola Brubeck",
    year: 1955,
    miles: true
  },
  {
    title: "Indian Summer (An American Idyll)",
    composer: "Victor Herbert/Al Dubin",
    year: 1919
  },
  {
    title: "Indiana",
    composer: "James Hanley/Ballard MacDonald",
    year: 1917
  },
  {
    title: "Inner Urge",
    composer: "Joe Henderson",
    year: 1964
  },
  {
    title: "Introspection",
    composer: "Thelonious Monk",
    year: 1947
  },
  {
    title: "Invitation",
    composer: "Bronislaw Kaper/Paul Francis Webster",
    year: 1952,
    latin: true
  },
  {
    title: "Isfahan",
    composer: "Billy Strayhorn & Duke Ellington",
    year: 1965
  },
  {
    title: "Isn't It a Pity?",
    composer: "George Gershwin/Ira Gershwin",
    year: 1933,
    ballad: true
  },
  {
    title: "Israel",
    composer: "John E. Carisi",
    year: 1949,
    blues: true,
    minor: true
  },
  {
    title: "Isn't It Romantic?",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1932
  },
  {
    title: "Isn't This a Lovely Day?",
    composer: "Irving Berlin",
    year: 1935
  },
  {
    title: "Isotope",
    composer: "Joe Henderson",
    year: 1964,
    blues: true
  },
  {
    title: "It Ain't Necessarily So",
    composer: "George Gershwin/Ira Gershwin & DuBose Heyward",
    year: 1934
  },
  {
    title: "It Could Happen to You",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1944,
    miles: true
  },
  {
    title: "It Don't Mean a Thing (If It Ain't Got That Swing)",
    composer: "Duke Ellington/Irving Mills",
    year: 1931
  },
  {
    title: "It Had to Be You",
    composer: "Isham Jones/Gus Kahn",
    year: 1924
  },
  {
    title: "It Might As Well Be Spring",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1945
  },
  {
    title: "It Never Entered My Mind",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1940,
    miles: true,
    ballad: true
  },
  {
    title: "It's a Sin to Tell a Lie",
    composer: "Billy Mayhew",
    year: 1936
  },
  {
    title: "It's All Right With Me",
    composer: "Cole Porter",
    year: 1953
  },
  {
    title: "It's Always You",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1940
  },
  {
    title: "It's Beginning to Look a Lot Like Christmas",
    composer: "Meredith Willson",
    year: 1951,
    holiday: true
  },
  {
    title: "It's De-Lovely",
    composer: "Cole Porter",
    year: 1936
  },
  {
    title: "It's Easy to Remember",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1935,
    ballad: true
  },
  {
    title: "It's Only a Paper Moon",
    composer: "Harold Arlen/Yip Harburg & Billy Rose",
    year: 1932
  },
  {
    title: "It's the Most Wonderful Time of the Year",
    composer: "Edward Pola & George Wyle",
    year: 1963,
    holiday: true
  },
  {
    title: "It's the Talk of the Town",
    composer: "Jerry Livingston/Al J. Neiburg & Marty Symes",
    year: 1933
  },
  {
    title: "It's You Or No One",
    composer: "Jule Styne/Sammy Cahn",
    year: 1948
  },
  {
    title: "J Mood",
    composer: "Wynton Marsalis",
    year: 1985
  },
  {
    title: "Jackie-ing",
    composer: "Thelonious Monk",
    year: 1959
  },
  {
    title: "Japanese Folk Song (Kōjō No Tsuki)",
    composer: "Rentarō Taki",
    year: 1901
  },
  {
    title: "Jeannine",
    composer: "Duke Pearson",
    year: 1960
  },
  {
    title: "Jessica",
    composer: "Herbie Hancock",
    year: 1969,
    ballad: true
  },
  {
    title: "Jingle Bells (One Horse Open Sleigh)",
    composer: "James Lord Pierpont",
    year: 1857,
    holiday: true
  },
  {
    title: "Jinrikisha",
    composer: "Joe Henderson",
    year: 1963
  },
  {
    title: "John's Abbey",
    composer: "Bud Powell",
    year: 1958,
    rhythm: true
  },
  {
    title: "Johnny Come Lately",
    composer: "Billy Strayhorn",
    year: 1944
  },
  {
    title: "Jordu",
    composer: "Duke Jordan",
    year: 1953
  },
  {
    title: "Joshua",
    composer: "Victor Feldman & Miles Davis",
    year: 1963
  },
  {
    title: "JuJu",
    composer: "Wayne Shorter",
    year: 1964
  },
  {
    title: "Jump City",
    composer: "Bud Powell",
    year: 1956
  },
  {
    title: "Jumpin' at the Woodside",
    composer: "Count Basie/Eddie Durham",
    year: 1938
  },
  {
    title: "Jumpin' with Symphony Sid",
    composer: "Lester Young",
    year: 1946,
    rhythm: true
  },
  {
    title: "Just a Gigolo",
    composer: "Irving Caesar & Leonello Casucci/Julius Brammer",
    year: 1929,
    ballad: true
  },
  {
    title: "Just A-Sittin' and A-Rockin'",
    composer: "Billy Strayhorn & Duke Ellington/Lee Gaines",
    year: 1941
  },
  {
    title: "Just As Though You Were Here",
    composer: "John Benson Brooks/Eddie DeLange",
    year: 1942
  },
  {
    title: "Just By Myself",
    composer: "Benny Golson",
    year: 1957
  },
  {
    title: "Just Friends",
    composer: "John Klenner/Sam M. Lewis",
    year: 1931
  },
  {
    title: "Just In Time",
    composer: "Jule Styne/Betty Comden & Adolph Green",
    year: 1956,
    sinatra: true
  },
  {
    title: "Just One of Those Things",
    composer: "Cole Porter",
    year: 1935
  },
  {
    title: "Just Open Your Heart",
    composer: "Barry Harris",
    year: 1969
  },
  {
    title: "Just Squeeze Me (But Please Don't Tease Me)",
    composer: "Duke Ellington/Lee Gaines",
    year: 1941
  },
  {
    title: "Just You, Just Me",
    composer: "Jesse Greer/Raymond Klages",
    year: 1929
  },
  {
    title: "K.C. Blues",
    composer: "Charlie Parker",
    year: 1951,
    blues: true
  },
  {
    title: "Keepin' in the Groove",
    composer: "Bud Powell",
    year: 1957,
    blues: true
  },
  {
    title: "Killer Joe",
    composer: "Benny Golson",
    year: 1959
  },
  {
    title: "King Porter Stomp",
    composer: "Jelly Roll Morton",
    year: 1910
  },
  {
    title: "Klactoveedsedstene",
    composer: "Charlie Parker",
    year: 1947
  },
  {
    title: "Klaunstance",
    composer: "Charlie Parker",
    year: 1947
  },
  {
    title: "Ko-Ko",
    composer: "Charlie Parker",
    year: 1945
  },
  {
    title: "L-O-V-E",
    composer: "Bert Kaempfert/Milt Gabler",
    year: 1964,
    sinatra: true
  },
  {
    title: "La Mesha",
    composer: "Kenny Dorham",
    year: 1963,
    ballad: true
  },
  {
    title: "La Vie en Rose",
    composer: "Edith Piaf",
    year: 1945,
    ballad: true
  },
  {
    title: "Lady Bird",
    composer: "Tadd Dameron",
    year: 1939
  },
  {
    title: "Laird Bird",
    composer: "Charlie Parker",
    year: 1952,
    blues: true
  },
  {
    title: "Lament",
    composer: "J. J. Johnson",
    year: 1954,
    ballad: true
  },
  {
    title: "Last Night When We Were Young",
    composer: "Harold Arlen/Yip Harburg",
    year: 1935,
    ballad: true
  },
  {
    title: "Laura",
    composer: "David Raksin/Johnny Mercer",
    year: 1945
  },
  {
    title: "Laverne Walk",
    composer: "Oscar Pettiford",
    year: 1959,
    rhythm: true
  },
  {
    title: "Lazy Afternoon",
    composer: "Jerome Moross/John Latouche",
    year: 1954
  },
  {
    title: "Lazy Bird",
    composer: "John Coltrane",
    year: 1957
  },
  {
    title: "Lazy River",
    composer: "Hoagy Carmichael/Sidney Arodin",
    year: 1931
  },
  {
    title: "Leap Frog",
    composer: "Charlie Parker",
    year: 1950
  },
  {
    title: "Lester Leaps In",
    composer: "Lester Young",
    year: 1940,
    rhythm: true
  },
  {
    title: "Let It Snow! Let It Snow! Let It Snow!",
    composer: "Jule Styne/Sammy Cahn",
    year: 1945,
    holiday: true
  },
  {
    title: "Let's Call the Whole Thing Off",
    composer: "George Gershwin/Ira Gershwin",
    year: 1937
  },
  {
    title: "Let's Call This",
    composer: "Thelonious Monk",
    year: 1953
  },
  {
    title: "Let's Cool One",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "Let's Do It (Let's Fall in Love)",
    composer: "Cole Porter",
    year: 1928
  },
  {
    title: "Let's Face the Music and Dance",
    composer: "Irving Berlin",
    year: 1936
  },
  {
    title: "Let's Fall in Love",
    composer: "Harold Arlen/Ted Koehler",
    year: 1934
  },
  {
    title: "Let's Get Lost",
    composer: "Jimmy McHugh/Frank Loesser",
    year: 1943
  },
  {
    title: "Light Blue",
    composer: "Thelonious Monk",
    year: 1957
  },
  {
    title: "Li'l Darlin'",
    composer: "Neal Hefti",
    year: 1957
  },
  {
    title: "Like Someone in Love",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1944
  },
  {
    title: "Limehouse Blues",
    composer: "Philip Braham/Douglas Furber",
    year: 1922
  },
  {
    title: "Little B's Poem",
    composer: "Bobby Hutcherson",
    year: 1966,
    waltz: true
  },
  {
    title: "Little Girl Blue",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1935
  },
  {
    title: "Little Melonae",
    composer: "Jackie McLean",
    year: 1955,
    miles: true
  },
  {
    title: "Little Niles",
    composer: "Randy Weston",
    year: 1958,
    waltz: true
  },
  {
    title: "Little Old Lady",
    composer: "Hoagy Carmichael/Stanley Adams",
    year: 1936
  },
  {
    title: "Little Rootie Tootie",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "Little Willie Leaps",
    composer: "Miles Davis",
    year: 1947,
    contrafact: true
  },
  {
    title: "Liza (All the Clouds'll Roll Away)",
    composer: "George Gershwin/Ira Gershwin & Gus Khan",
    year: 1929
  },
  {
    title: "Locomotive",
    composer: "Thelonious Monk",
    year: 1954
  },
  {
    title: "Lolita",
    composer: "Barry Harris",
    year: 1960
  },
  {
    title: "Lonely Woman",
    composer: "Horace Silver",
    year: 1963,
    ballad: true
  },
  {
    title: "Long Ago (and Far Away)",
    composer: "Jerome Kern/Ira Gershwin",
    year: 1944
  },
  {
    title: "Long Tall Dexter",
    composer: "Dexter Gordon",
    year: 1946,
    blues: true
  },
  {
    title: "Look For the Silver Lining",
    composer: "Jerome Kern/Buddy DeSylva",
    year: 1919
  },
  {
    title: "Lotus Blossom",
    composer: "Billy Strayhorn",
    year: 1947,
    waltz: true,
    ballad: true
  },
  {
    title: "Lotus Blossom ",
    composer: "Kenny Dorham",
    year: 1957
  },
  {
    title: "Louise",
    composer: "Richard A. Whiting/Leo Robin",
    year: 1929
  },
  {
    title: "Love For Sale",
    composer: "Cole Porter",
    year: 1930
  },
  {
    title: "Love Is Here to Stay",
    composer: "George Gershwin/Ira Gershwin",
    year: 1937
  },
  {
    title: "Love Letters",
    composer: "Victor Young/Edward Heyman",
    year: 1945
  },
  {
    title: "Love Me or Leave Me",
    composer: "Walter Donaldson/Gus Kahn",
    year: 1928
  },
  {
    title: "Love Walked In",
    composer: "George Gershwin/Ira Gershwin",
    year: 1930
  },
  {
    title: "Love You Madly",
    composer: "Duke Ellington",
    year: 1950,
    rhythm: true
  },
  {
    title: "Lovely to Look At",
    composer: "Jerome Kern/Dorothy Fields",
    year: 1935
  },
  {
    title: "Lover",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1932
  },
  {
    title: "Lover Come Back to Me",
    composer: "Sigmund Romberg/Oscar Hammerstein II",
    year: 1928
  },
  {
    title: "Lover Man (Oh, Where Can You Be?)",
    composer: "Jimmy Davis, Ram Ramirez, James Sherman",
    year: 1941,
    ballad: true
  },
  {
    title: "Lucky To Be Me",
    composer: "Leonard Bernstein/Betty Comden & Adolph Green",
    year: 1944
  },
  {
    title: "Lullaby in Rhythm",
    composer: "Benny Goodman, Edgar Sampson, Clarence Profit/Walter Hirsch",
    year: 1938
  },
  {
    title: "Lullaby of Birdland",
    composer: "George Shearing/George Weiss",
    year: 1952
  },
  {
    title: "Lullaby of the Leaves",
    composer: "Bernice Petkere/Joseph Young",
    year: 1932
  },
  {
    title: "Lulu's Back in Town",
    composer: "Harry Warren/Al Dubin",
    year: 1935
  },
  {
    title: "Lush Life",
    composer: "Billy Strayhorn",
    year: 1936,
    ballad: true
  },
  {
    title: "Mack the Knife (Moritat)",
    composer: "Kurt Weill/Marc Blitzstein & Bertolt Brecht",
    year: 1928
  },
  {
    title: "Make Believe",
    composer: "Jerome Kern/Oscar Hammerstein II",
    year: 1927
  },
  {
    title: "Make Someone Happy",
    composer: "Jule Styne/Betty Comden & Adolph Green",
    year: 1960,
    ballad: true
  },
  {
    title: "Maiden Voyage",
    composer: "Herbie Hancock",
    year: 1965
  },
  {
    title: "Makin' Whoopee",
    composer: "Walter Donaldson/Gus Kahn",
    year: 1928
  },
  {
    title: "Mambo Inn",
    composer: "Mario Bauzá",
    year: 1952
  },
  {
    title: "Manhã de Carnaval (Black Orpheus)",
    composer: "Luiz Bonfá/Antônio Maria & Carl Sigman",
    year: 1959,
    latin: true
  },
  {
    title: "Manhattan",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1925,
    ballad: true
  },
  {
    title: "Marmaduke",
    composer: "Charlie Parker",
    year: 1948,
    contrafact: true
  },
  {
    title: "Marmalade",
    composer: "Bud Powell",
    year: 1958,
    rhythm: true
  },
  {
    title: "Martha's Prize",
    composer: "Cedar Walton",
    year: 1991
  },
  {
    title: "Mating Call",
    composer: "Tadd Dameron",
    year: 1956
  },
  {
    title: "Max Making Wax",
    composer: "Charlie Parker",
    year: 1946,
    rhythm: true
  },
  {
    title: "Mean to Me",
    composer: "Fred E. Ahlert/Roy Turk",
    year: 1929
  },
  {
    title: "Meandering",
    composer: "Charlie Parker",
    year: 1945
  },
  {
    title: "Meditation",
    composer: "Antonio Carlos Jobim",
    year: 1962,
    latin: true
  },
  {
    title: "Melancholia",
    composer: "Duke Ellington",
    year: 1953,
    ballad: true
  },
  {
    title: "Memories of You",
    composer: "Eubie Blake/Andy Razaf",
    year: 1930
  },
  {
    title: "Memphis in June",
    composer: "Hoagy Carmichael/Paul Francis Webster",
    year: 1945
  },
  {
    title: "Merry Go Round",
    composer: "Charlie Parker",
    year: 1948,
    rhythm: true
  },
  {
    title: "Midnight Sun",
    composer: "Lionel Hampton & Sonny Burke/Johnny Mercer",
    year: 1947
  },
  {
    title: "Midway",
    composer: "Bud Powell",
    year: 1957
  },
  {
    title: "Miles Ahead",
    composer: "Miles Davis",
    year: 1953
  },
  {
    title: "Milestones (old)",
    composer: "John Lewis",
    year: 1947
  },
  {
    title: "Milestones (new)",
    composer: "Miles Davis",
    year: 1958
  },
  {
    title: "Minor Mishap",
    composer: "Tommy Flanagan",
    year: 1957,
    minor: true
  },
  {
    title: "Minority",
    composer: "Gigi Gryce",
    year: 1953,
    minor: true
  },
  {
    title: "Miss Brown to You",
    composer: "Richard A. Whiting & Ralph Rainger/Leo Robin",
    year: 1935
  },
  {
    title: "Miss Otis Regrets",
    composer: "Cole Porter",
    year: 1934
  },
  {
    title: "Misterioso",
    composer: "Thelonious Monk",
    year: 1948,
    blues: true
  },
  {
    title: "Misty",
    composer: "Erroll Garner/Johnny Burke",
    year: 1954,
    ballad: true
  },
  {
    title: "Moanin'",
    composer: "Bobby Timmons",
    year: 1958
  },
  {
    title: "Mode for Joe",
    composer: "Cedar Walton",
    year: 1966
  },
  {
    title: "Mohawk",
    composer: "Charlie Parker",
    year: 1950,
    blues: true
  },
  {
    title: "Moment to Moment",
    composer: "Henry Mancini/Johnny Mercer",
    year: 1965
  },
  {
    title: "Moment's Notice",
    composer: "John Coltrane",
    year: 1957
  },
  {
    title: "Mona Lisa",
    composer: "Jay Livingston/Ray Evans",
    year: 1950,
    ballad: true
  },
  {
    title: "Monk's Dream",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "Monk's Mood",
    composer: "Thelonious Monk",
    year: 1947,
    ballad: true
  },
  {
    title: "Monk's Point",
    composer: "Thelonious Monk",
    year: 1964,
    blues: true
  },
  {
    title: "Monopoly",
    composer: "Bud Powell",
    year: 1958,
    rhythm: true
  },
  {
    title: "Mood Indigo",
    composer: "Duke Ellington & Barney Bigard",
    year: 1930,
    ballad: true
  },
  {
    title: "Moon Ray",
    composer: "Artie Shaw, Paul Madison & Arthur Quenzer",
    year: 1939
  },
  {
    title: "Moon River",
    composer: "Henry Mancini/Johnny Mercer",
    year: 1961,
    waltz: true
  },
  {
    title: "Moonglow",
    composer: "Will Hudson/Eddie De Lange",
    year: 1934
  },
  {
    title: "Moonlight Becomes You",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1942
  },
  {
    title: "Moonlight in Vermont",
    composer: "Karl Suessdorf/John M. Blackburn",
    year: 1944,
    ballad: true
  },
  {
    title: "Moose the Mooche",
    composer: "Charlie Parker",
    year: 1946,
    rhythm: true
  },
  {
    title: "More Than You Know",
    composer: "Vincent Youmans/Billy Rose & Edward Eliscu",
    year: 1929,
    ballad: true
  },
  {
    title: "Mosaic",
    composer: "Cedar Walton",
    year: 1961
  },
  {
    title: "Moten Swing",
    composer: "Bennie Moten, Buster Moten",
    year: 1932
  },
  {
    title: "Mountain Greenery",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1926
  },
  {
    title: "Move",
    composer: "Denzil Best",
    year: 1949
  },
  {
    title: "Mr. P.C.",
    composer: "John Coltrane",
    year: 1959,
    blues: true,
    minor: true
  },
  {
    title: "My Baby Just Cares for Me",
    composer: "Walter Donaldson/Gus Kahn",
    year: 1930
  },
  {
    title: "My Blue Heaven",
    composer: "Walter Donaldson/George Whiting",
    year: 1927
  },
  {
    title: "My Buddy",
    composer: "Walter Donaldson/Gus Kahn",
    year: 1922
  },
  {
    title: "My Devotion",
    composer: "Bud Powell",
    year: 1953,
    ballad: true
  },
  {
    title: "My Favorite Things",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1959,
    waltz: true
  },
  {
    title: "My Foolish Heart",
    composer: "Victor Young/Ned Washington",
    year: 1949,
    ballad: true
  },
  {
    title: "My Funny Valentine",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1937,
    ballad: true
  },
  {
    title: "My Heart Belongs to Daddy",
    composer: "Cole Porter",
    year: 1938
  },
  {
    title: "My Heart Stood Still",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1927
  },
  {
    title: "My Ideal",
    composer: "Richard A. Whiting & Newell Chase/Leo Robin",
    year: 1930
  },
  {
    title: "My Little Brown Book",
    composer: "Billy Strayhorn",
    year: 1935
  },
  {
    title: "My Little Suede Shoes",
    composer: "Charlie Parker",
    year: 1951,
    latin: true
  },
  {
    title: "My Man's Gone Now",
    composer: "George Gershwin/Ira Gershwin & DuBose Heyward",
    year: 1934
  },
  {
    title: "My Melancholy Baby",
    composer: "Ernie Burnett/George A. Norton",
    year: 1911
  },
  {
    title: "My Old Flame",
    composer: "Arthur Johnson/Sam Coslow",
    year: 1934,
    ballad: true
  },
  {
    title: "My One and Only (What Am I Gonna Do?)",
    composer: "George Gershwin/Ira Gershwin",
    year: 1927
  },
  {
    title: "My One and Only Love",
    composer: "Guy Wood, Robert Mellin",
    year: 1952,
    ballad: true
  },
  {
    title: "My Romance",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1935,
    ballad: true
  },
  {
    title: "My Shining Hour",
    composer: "Harold Arlen/Johnny Mercer",
    year: 1943
  },
  {
    title: "My Ship",
    composer: "Kurt Weill/Ira Gershwin",
    year: 1941,
    ballad: true
  },
  {
    title: "N.P.S.",
    composer: "Cedar Walton",
    year: 1980
  },
  {
    title: "Naima",
    composer: "John Coltrane",
    year: 1959,
    ballad: true
  },
  {
    title: "Namely You",
    composer: "Gene De Paul/Johnny Mercer",
    year: 1956
  },
  {
    title: "Nancy (with the Laughing Face)",
    composer: "Jimmy Van Heusen/Phil Silvers",
    year: 1944,
    ballad: true
  },
  {
    title: "Nardis",
    composer: "Miles Davis",
    year: 1958
  },
  {
    title: "Nascimento",
    composer: "Barry Harris",
    year: 1979,
    latin: true
  },
  {
    title: "Nature Boy",
    composer: "Eden Ahbez",
    year: 1948
  },
  {
    title: "Never Let Me Go",
    composer: "Jay Livingston/Ray Evans",
    year: 1956,
    ballad: true
  },
  {
    title: "Nevertheless (I'm in Love with You)",
    composer: "Harry Ruby/Bert Kalmar",
    year: 1931
  },
  {
    title: "New Orleans",
    composer: "Hoagy Carmichael",
    year: 1932
  },
  {
    title: "Nica's Dream",
    composer: "Horace Silver",
    year: 1956
  },
  {
    title: "Nica's Tempo",
    composer: "Gigi Gryce",
    year: 1955
  },
  {
    title: "Nice Work If You Can Get It",
    composer: "George Gershwin/Ira Gershwin",
    year: 1937
  },
  {
    title: "Night and Day",
    composer: "Cole Porter",
    year: 1932
  },
  {
    title: "Night Dreamer",
    composer: "Wayne Shorter",
    year: 1964,
    waltz: true
  },
  {
    title: "No More",
    composer: "Toots Camarata/Bob Russell",
    year: 1944
  },
  {
    title: "North of the Sunset",
    composer: "Thelonious Monk",
    year: 1964,
    blues: true
  },
  {
    title: "Nostalgia",
    composer: "Tadd Dameron",
    year: 1947,
    contrafact: true
  },
  {
    title: "Nutty",
    composer: "Thelonious Monk",
    year: 1954,
    rhythm: true
  },
  {
    title: "O Christmas Tree (O Tannenbaum)",
    composer: "Ernst Anschutz",
    year: 1824,
    holiday: true
  },
  {
    title: "O Come, All ye Faithful (Adeste Fidelis)",
    composer: "John Francis Wade",
    year: 1751,
    holiday: true
  },
  {
    title: "O Holy Night",
    composer: "Adolphe Adam",
    year: 1847,
    holiday: true
  },
  {
    title: "Oblivion",
    composer: "Bud Powell",
    year: 1951
  },
  {
    title: "Off Minor",
    composer: "Thelonious Monk",
    year: 1947
  },
  {
    title: "Oh, Lady Be Good!",
    composer: "George Gershwin/Ira Gershwin",
    year: 1924
  },
  {
    title: "Oh, What a Beautiful Mornin'",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1943
  },
  {
    title: "Ojos de Rojo",
    composer: "Cedar Walton",
    year: 1977
  },
  {
    title: "Old Devil Moon",
    composer: "Burton Lane/Yip Harburg",
    year: 1946
  },
  {
    title: "Old Folks",
    composer: "Willard Robison/Dedette Lee Hill",
    year: 1938,
    ballad: true
  },
  {
    title: "Oleo",
    composer: "Sonny Rollins",
    year: 1954,
    rhythm: true,
    miles: true
  },
  {
    title: "Oliloqui Valley",
    composer: "Herbie Hancock",
    year: 1964
  },
  {
    title: "Omicron",
    composer: "Donald Byrd",
    year: 1956,
    contrafact: true
  },
  {
    title: "On A Clear Day (You Can See Forever)",
    composer: "Burton Lane/Alan Jay Lerner",
    year: 1966
  },
  {
    title: "On A Misty Night",
    composer: "Tadd Dameron",
    year: 1956,
    contrafact: true
  },
  {
    title: "On Green Dolphin Street",
    composer: "Bronislaw Kaper/Ned Washington",
    year: 1947,
    miles: true
  },
  {
    title: "On Stage",
    composer: "Rudy Stevenson",
    year: 1960
  },
  {
    title: "On the Alamo",
    composer: "Isham Jones/Gus Kahn",
    year: 1922
  },
  {
    title: "On the Street Where You Live",
    composer: "Frederick Loewe/Alan Jay Lerner",
    year: 1956
  },
  {
    title: "On the Sunny Side of the Street",
    composer: "Jimmy McHugh/Dorothy Fields",
    year: 1930
  },
  {
    title: "On the Trail",
    composer: "Ferde Grofe",
    year: 1933
  },
  {
    title: "Once I Loved",
    composer: "Antonio Carlos Jobim",
    year: 1963,
    latin: true
  },
  {
    title: "Once in a While",
    composer: "Michael Edwards/Bud Green",
    year: 1937
  },
  {
    title: "One Finger Snap",
    composer: "Herbie Hancock",
    year: 1964
  },
  {
    title: "One for My Baby (and One More for the Road)",
    composer: "Harold Arlen/Johnny Mercer",
    year: 1943,
    ballad: true,
    sinatra: true
  },
  {
    title: "One Morning in May",
    composer: "Hoagy Carmichael/Mitchell Parish",
    year: 1943
  },
  {
    title: "One Note Samba",
    composer: "Antonio Carlos Jobim",
    year: 1961,
    latin: true
  },
  {
    title: "One O'clock Jump",
    composer: "Count Basie",
    year: 1937
  },
  {
    title: "Only Trust Your Heart",
    composer: "Benny Carter/Sammy Cahn",
    year: 1964,
    latin: true
  },
  {
    title: "Ornithology",
    composer: "Charlie Parker & Benny Harris",
    year: 1945
  },
  {
    title: "Oska T",
    composer: "Thelonious Monk",
    year: 1963
  },
  {
    title: "Our Delight",
    composer: "Tadd Dameron",
    year: 1946
  },
  {
    title: "Out of Nowhere",
    composer: "Johnny Green/Edward Heyman",
    year: 1931
  },
  {
    title: "Out of the Past",
    composer: "Benny Golson",
    year: 1955
  },
  {
    title: "Out of This World",
    composer: "Harold Arlen/Johnny Mercer",
    year: 1945
  },
  {
    title: "Over the Rainbow",
    composer: "Harold Arlen/Yip Harburg",
    year: 1939,
    ballad: true
  },
  {
    title: "Pannonica",
    composer: "Thelonious Monk",
    year: 1956,
    ballad: true
  },
  {
    title: "Parisian Thoroughfare",
    composer: "Bud Powell",
    year: 1951
  },
  {
    title: "Passion Flower",
    composer: "Billy Strayhorn",
    year: 1944,
    ballad: true
  },
  {
    title: "Passport",
    composer: "Charlie Parker",
    year: 1949,
    rhythm: true
  },
  {
    title: "Peace",
    composer: "Horace Silver",
    year: 1959,
    ballad: true
  },
  {
    title: "Pennies from Heaven",
    composer: "Arthur Johnston/Johnny Burke",
    year: 1936
  },
  {
    title: "Pensativa",
    composer: "Clare Fischer",
    year: 1962,
    latin: true
  },
  {
    title: "People Will Say We're in Love",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1943
  },
  {
    title: "Perdido",
    composer: "Juan Tizol/Ervin Drake & Hans Jan Lengsfelder",
    year: 1941
  },
  {
    title: "Perhaps",
    composer: "Charlie Parker",
    year: 1948,
    blues: true
  },
  {
    title: "Personality",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1946
  },
  {
    title: "Philly Twist",
    composer: "Kenny Dorham",
    year: 1961,
    blues: true
  },
  {
    title: "Phryzinnian Man",
    composer: "Wynton Marsalis",
    year: 1985
  },
  {
    title: "Pick Yourself Up",
    composer: "Jerome Kern/Dorothy Fields",
    year: 1936
  },
  {
    title: "Pitter Panther Patter",
    composer: "Duke Ellington",
    year: 1940,
    feature: "bass"
  },
  {
    title: "Played Twice",
    composer: "Thelonious Monk",
    year: 1959
  },
  {
    title: "Please Send Me Someone to Love",
    composer: "Percy Mayfield",
    year: 1950
  },
  {
    title: "Poinciana",
    composer: "Nat Simon/Buddy Bernier",
    year: 1936,
    latin: true
  },
  {
    title: "Polka Dots and Moonbeams",
    composer: "Jimmy Van Heusen/Johnny Burke",
    year: 1940,
    ballad: true
  },
  {
    title: "Poor Butterfly",
    composer: "Raymond Hubbell/John L. Golden",
    year: 1916
  },
  {
    title: "Portrait of a Mountain",
    composer: "Mulgrew Miller",
    year: 1985
  },
  {
    title: "Portrait of Jennie",
    composer: "J. Russel Robinson/Gordon Burge",
    year: 1948,
    ballad: true
  },
  {
    title: "Powell's Prances",
    composer: "Richie Powell",
    year: 1956
  },
  {
    title: "Prelude to a Kiss",
    composer: "Duke Ellington/Irving Gordon & Irving Mills",
    year: 1938,
    ballad: true
  },
  {
    title: "Promethean",
    composer: "Mulgrew Miller",
    year: 1985
  },
  {
    title: "Punjab",
    composer: "Joe Henderson",
    year: 1964
  },
  {
    title: "Quasimodo",
    composer: "Charlie Parker",
    year: 1947,
    contrafact: true
  },
  {
    title: "Que Sera Sera",
    composer: "Jay Livingston/Ray Evans",
    year: 1956
  },
  {
    title: "Raincheck",
    composer: "Billy Strayhorn",
    year: 1942
  },
  {
    title: "Raise Four",
    composer: "Thelonious Monk",
    year: 1967,
    blues: true
  },
  {
    title: "Ray's Idea",
    composer: "Ray Brown/Gil Fuller",
    year: 1947
  },
  {
    title: "Recorda-Me",
    composer: "Joe Henderson",
    year: 1963,
    latin: true
  },
  {
    title: "Red Cross",
    composer: "Charlie Parker",
    year: 1944,
    rhythm: true
  },
  {
    title: "Reets and I",
    composer: "Benny Harris",
    year: 1953,
    contrafact: true
  },
  {
    title: "Reflections",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "Reflections in D",
    composer: "Duke Ellington",
    year: 1953,
    ballad: true
  },
  {
    title: "Relaxin' at Camarillo",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "Relaxin' with Lee",
    composer: "Charlie Parker",
    year: 1950
  },
  {
    title: "Remember",
    composer: "Irving Berlin",
    year: 1925
  },
  {
    title: "Repetition",
    composer: "Neal Hefti",
    year: 1947,
    latin: true
  },
  {
    title: "Retrospection",
    composer: "Duke Ellington",
    year: 1953,
    ballad: true
  },
  {
    title: "Rhythm-a-ning",
    composer: "Thelonious Monk",
    year: 1957,
    rhythm: true
  },
  {
    title: "Riot",
    composer: "Herbie Hancock",
    year: 1968
  },
  {
    title: "Robbins Nest",
    composer: "Charles Thompson & Illinois Jacquet",
    year: 1947
  },
  {
    title: "Rock-a-Bye Your Baby with a Dixie Melody",
    composer: "Jean Schwartz/Sam M. Lewis & Joe Young",
    year: 1918
  },
  {
    title: "Rockin' Chair",
    composer: "Hoagy Carmichael",
    year: 1929
  },
  {
    title: "Rockin' in Rhythm",
    composer: "Duke Ellington & Harry Carney/Irving Mills",
    year: 1931
  },
  {
    title: "Rose Room",
    composer: "Art Hickman/Harry Williams",
    year: 1917
  },
  {
    title: "Rosetta",
    composer: "Earl Hines/Henri Woode",
    year: 1933
  },
  {
    title: "Round Midnight",
    composer: "Thelonious Monk & Cootie Williams",
    year: 1944,
    miles: true,
    ballad: true
  },
  {
    title: "Royal Garden Blues",
    composer: "Clarence Williams & Spencer Williams",
    year: 1919,
    blues: true
  },
  {
    title: "Ruby, My Dear",
    composer: "Thelonious Monk",
    year: 1947,
    ballad: true
  },
  {
    title: "Rudolph the Red-Nosed Reindeer",
    composer: "Johnny Marks",
    year: 1949,
    holiday: true
  },
  {
    title: "Russian Lullaby",
    composer: "Irving Berlin",
    year: 1927
  },
  {
    title: "S'Wonderful",
    composer: "George Gershwin/Ira Gershwin",
    year: 1927
  },
  {
    title: "Saint James Infirmary",
    composer: "Traditional",
    year: 1928
  },
  {
    title: "Saint Louis Blues",
    composer: "W. C. Handy",
    year: 1914,
    blues: true
  },
  {
    title: "Saint Thomas",
    composer: "Sonny Rollins",
    year: 1955,
    latin: true
  },
  {
    title: "Salt Peanuts",
    composer: "Dizzy Gillespie & Kenny Clarke",
    year: 1942,
    miles: true
  },
  {
    title: "San Francisco Holiday (Worry Later)",
    composer: "Thelonious Monk",
    year: 1960
  },
  {
    title: "Santa Baby",
    composer: "Joan Javits & Philip Springer",
    year: 1953,
    holiday: true
  },
  {
    title: "Santa Claus is Coming to Town",
    composer: "J. Fred Coots/Haven Gillespie",
    year: 1934,
    holiday: true
  },
  {
    title: "Sao Paolo",
    composer: "Kenny Dorham",
    year: 1963
  },
  {
    title: "Satin Doll",
    composer: "Billy Strayhorn & Duke Ellington/Johnny Mercer",
    year: 1953
  },
  {
    title: "Saud's Run",
    composer: "Mulgrew Miller",
    year: 1985
  },
  {
    title: "Say It (Over and Over Again)",
    composer: "Jimmy McHugh/Frank Loesser",
    year: 1940,
    ballad: true
  },
  {
    title: "Scrapple from the Apple",
    composer: "Charlie Parker",
    year: 1947,
    contrafact: true
  },
  {
    title: "Second Balcony Jump",
    composer: "Billy Eckstine/Gerald Valentine",
    year: 1946,
    rhythm: true
  },
  {
    title: "Secret Love",
    composer: "Sammy Fain/Paul Francis Webster",
    year: 1953
  },
  {
    title: "Segment (Tune X)",
    composer: "Charlie Parker",
    year: 1949,
    minor: true
  },
  {
    title: "Send in the Clowns",
    composer: "Stephen Sondheim",
    year: 1973,
    ballad: true
  },
  {
    title: "September in the Rain",
    composer: "Harry Warren/Al Dubin",
    year: 1937
  },
  {
    title: "September Song",
    composer: "Kurt Weill/Maxwell Anderson",
    year: 1938,
    ballad: true
  },
  {
    title: "Serenata",
    composer: "Leroy Anderson",
    year: 1949
  },
  {
    title: "Serenity",
    composer: "Joe Henderson",
    year: 1964
  },
  {
    title: "Seven Steps to Heaven",
    composer: "Victor Feldman",
    year: 1963,
    miles: true
  },
  {
    title: "Shangri-La",
    composer: "Harry Warren/Jerome Lawrence & Robert E. Lee",
    year: 1956
  },
  {
    title: "Shaw Nuff",
    composer: "Charlie Parker & Dizzy Gillespie",
    year: 1945
  },
  {
    title: "She",
    composer: "Bud Powell",
    year: 1957
  },
  {
    title: "She Rote",
    composer: "Charlie Parker",
    year: 1950
  },
  {
    title: "She's Funny That Way",
    composer: "Charles N. Daniels/Richard A. Whiting",
    year: 1928
  },
  {
    title: "Shiny Stockings",
    composer: "Frank Foster/Ella Fitzgerald",
    year: 1955
  },
  {
    title: "Short Story",
    composer: "Kenny Dorham",
    year: 1963
  },
  {
    title: "Short Stuff",
    composer: "Cedar Walton",
    year: 1967
  },
  {
    title: "Shuffle Boil",
    composer: "Thelonious Monk",
    year: 1955
  },
  {
    title: "Si Si",
    composer: "Charlie Parker",
    year: 1951,
    blues: true
  },
  {
    title: "Silent Night",
    composer: "Franz Xavier Gruber/Joseph Mohr",
    year: 1818,
    holiday: true
  },
  {
    title: "Silver Bells",
    composer: "Jay Livingston/Ray Evans",
    year: 1950,
    holiday: true
  },
  {
    title: "Simone",
    composer: "Frank Foster",
    year: 1968,
    waltz: true
  },
  {
    title: "Sippin' at Bells",
    composer: "Miles Davis",
    year: 1947,
    blues: true
  },
  {
    title: "Six Eight",
    composer: "Rudy Stevenson",
    year: 1965
  },
  {
    title: "Sixteen",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "Skippy",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "Skylark",
    composer: "Hoagy Carmichael/Johnny Mercer",
    year: 1941,
    ballad: true
  },
  {
    title: "Sleigh Ride",
    composer: "Leroy Anderson/Mitchell Parish",
    year: 1948,
    holiday: true
  },
  {
    title: "Slow Boat to China",
    composer: "Frank Loesser",
    year: 1948
  },
  {
    title: "Smoke Gets in Your Eyes",
    composer: "Jerome Kern/Otto Harbach",
    year: 1933,
    ballad: true
  },
  {
    title: "Só Danço Samba",
    composer: "Antonio Carlos Jobim/Vincius De Morales & Norman Gimbel",
    year: 1963,
    latin: true
  },
  {
    title: "So In Love",
    composer: "Cole Porter",
    year: 1948
  },
  {
    title: "So Sorry Please",
    composer: "Bud Powell",
    year: 1950
  },
  {
    title: "So What",
    composer: "Miles Davis",
    year: 1959
  },
  {
    title: "Soft Winds",
    composer: "Benny Goodman/Fred Royal",
    year: 1940,
    blues: true
  },
  {
    title: "Softly As in a Morning Sunrise",
    composer: "Sigmund Romberg/Oscar Hammerstein II",
    year: 1928
  },
  {
    title: "Solar",
    composer: "Miles Davis",
    year: 1954
  },
  {
    title: "Solitude",
    composer: "Duke Ellington/Eddie De Lange & Irving Mills",
    year: 1934,
    ballad: true
  },
  {
    title: "Some Other Spring",
    composer: "Irene Kitchings/Arthur Herzog, Jr.",
    year: 1939,
    ballad: true
  },
  {
    title: "Somebody Loves Me",
    composer: "George Gershwin/Ballard MacDonald & Buddy DeSylva",
    year: 1924
  },
  {
    title: "Someday My Prince Will Come",
    composer: "Frank E. Churchill/Larry Morey",
    year: 1937,
    waltz: true,
    miles: true
  },
  {
    title: "Someone To Watch Over Me",
    composer: "George Gershwin/Ira Gershwin",
    year: 1926,
    ballad: true
  },
  {
    title: "Something I Dreamed Last Night",
    composer: "Sammy Fain/Jack Yellen, Herb Magidson",
    year: 1939,
    miles: true
  },
  {
    title: "Something to Live For",
    composer: "Billy Strayhorn & Duke Ellington",
    year: 1939,
    ballad: true
  },
  {
    title: "Something Wonderful",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1951,
    ballad: true
  },
  {
    title: "Sometimes I'm Happy",
    composer: "Vincent Youmans/Irving Caesar",
    year: 1925
  },
  {
    title: "Song for Darnell",
    composer: "Mulgrew Miller",
    year: 1985
  },
  {
    title: "Song for my Father",
    composer: "Horace Silver",
    year: 1964,
    lating: true
  },
  {
    title: "Sonny Side",
    composer: "Sonny Stitt",
    year: 1949
  },
  {
    title: "Soon",
    composer: "George Gershwin/Ira Gershwin",
    year: 1927
  },
  {
    title: "Sophisticated Lady",
    composer: "Duke Ellington/Irving Mills & Mitchell Parish",
    year: 1933,
    ballad: true
  },
  {
    title: "Soul Eyes",
    composer: "Mal Waldron",
    year: 1957,
    ballad: true
  },
  {
    title: "Soultrane",
    composer: "Tadd Dameron",
    year: 1956,
    ballad: true
  },
  {
    title: "Speak Like a Child",
    composer: "Herbie Hancock",
    year: 1968,
    latin: true
  },
  {
    title: "Speak Low",
    composer: "Kurt Weill/Ogden Nash",
    year: 1943
  },
  {
    title: "Speak No Evil",
    composer: "Wayne Shorter",
    year: 1965
  },
  {
    title: "Spring Cannon",
    composer: "Kenny Dorham",
    year: 1959
  },
  {
    title: "Spring is Here",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1938
  },
  {
    title: "Squatty Roo",
    composer: "Johnny Hodges",
    year: 1941
  },
  {
    title: "Squeeze Me",
    composer: "Fats Waller/Andy Razaf",
    year: 1925
  },
  {
    title: "Stablemates",
    composer: "Benny Golson",
    year: 1955
  },
  {
    title: "Stairway to the Stars (Park Avenue Fantasy)",
    composer: "Matt Malneck & Frank Signorelli/Mitchell Parish",
    year: 1935,
    ballad: true
  },
  {
    title: "Star Eyes",
    composer: "Gene De Paul/Don Raye",
    year: 1943,
    latin: true
  },
  {
    title: "Stardust",
    composer: "Hoagy Carmichael/Mitchell Parish",
    year: 1927,
    ballad: true
  },
  {
    title: "Stars Fell on Alabama",
    composer: "Frank S. Perkins/Mitchell Parish",
    year: 1934,
    ballad: true
  },
  {
    title: "Steeplechase",
    composer: "Charlie Parker",
    year: 1948,
    rhythm: true
  },
  {
    title: "Stella By Starlight",
    composer: "Victor Young/Ned Washington",
    year: 1946,
    miles: true,
    ballad: true
  },
  {
    title: "Stolen Moments",
    composer: "Oliver Nelson",
    year: 1961,
    blues: true,
    minor: true
  },
  {
    title: "Stompin' at the Savoy",
    composer: "Edgar Sampson/Andy Razaf",
    year: 1934
  },
  {
    title: "Stormy Weather",
    composer: "Harold Arlen/Ted Koehler",
    year: 1933
  },
  {
    title: "Straight, No Chaser",
    composer: "Thelonious Monk",
    year: 1951,
    blues: true
  },
  {
    title: "Straight Ahead",
    composer: "Kenny Dorham",
    year: 1963,
    rhythm: true
  },
  {
    title: "Straight Street",
    composer: "John Coltrane",
    year: 1957
  },
  {
    title: "Street of Dreams",
    composer: "Victor Young/Sam M. Lewis",
    year: 1932
  },
  {
    title: "Strictly Confidential",
    composer: "Bud Powell",
    year: 1949
  },
  {
    title: "Strike Up the Band",
    composer: "George Gershwin/Ira Gershwin",
    year: 1927
  },
  {
    title: "Strollin'",
    composer: "Horace Silver",
    year: 1960
  },
  {
    title: "Stuffy",
    composer: "Coleman Hawkins",
    year: 1945,
    rhythm: true
  },
  {
    title: "Stuffy Turkey",
    composer: "Thelonious Monk",
    year: 1964
  },
  {
    title: "Stupendous",
    composer: "Charlie Parker",
    year: 1947,
    contrafact: true
  },
  {
    title: "Sub City",
    composer: "Bud Powell",
    year: 1958,
    rhythm: true
  },
  {
    title: "Sublimity",
    composer: "Mulgrew Miller",
    year: 1986
  },
  {
    title: "Suburban Eyes",
    composer: "Thelonious Monk",
    year: 1947
  },
  {
    title: "Summertime",
    composer: "George Gershwin/Ira Gershwin & DuBose Heyward",
    year: 1934
  },
  {
    title: "Sunset and the Mockingbird",
    composer: "Billy Strayhorn & Duke Ellington",
    year: 1959
  },
  {
    title: "Super Jet",
    composer: "Tadd Dameron",
    year: 1957
  },
  {
    title: "Sure Thing",
    composer: "Bud Powell",
    year: 1953
  },
  {
    title: "Swedish Schnapps",
    composer: "Charlie Parker",
    year: 1951,
    rhythm: true
  },
  {
    title: "Swedish Pastry",
    composer: "Bud Powell",
    year: 1957,
    blues: true
  },
  {
    title: "Sweet and Lovely",
    composer: "Gus Arnheim, Charles N. Daniels & Harry Tobias",
    year: 1931
  },
  {
    title: "Sweet Georgia Brown",
    composer: "Ben Bernie, Ken Casey, Maceo Pinkard",
    year: 1925
  },
  {
    title: "Sweet Lorraine",
    composer: "Cliff Burwell/Mitchell Parish",
    year: 1928
  },
  {
    title: "Sweet Sue, Just You",
    composer: "Victor Young/Will J. Harris",
    year: 1928,
    miles: true
  },
  {
    title: "Smooth as the Wind",
    composer: "Tadd Dameron",
    year: 1961
  },
  {
    title: "Swingin' Til the Girls Come Home",
    composer: "Oscar Pettiford",
    year: 1951,
    blues: true
  },
  {
    title: "Tadd's Delight (Sid's Delight)",
    composer: "Tadd Dameron",
    year: 1949,
    miles: true
  },
  {
    title: 'Take the "A" Train',
    composer: "Billy Strayhorn",
    year: 1939
  },
  {
    title: "Taking a Chance on Love",
    composer: "Vernon Duke/Ted Fetter & John Latouche",
    year: 1940
  },
  {
    title: "Tangerine",
    composer: "Victor Schertzinger/Johnny Mercer",
    year: 1942
  },
  {
    title: "Tea for Two",
    composer: "Vincent Youmans/Irving Caesar",
    year: 1924
  },
  {
    title: "Teach Me Tonight",
    composer: "Gene De Paul/Sammy Cahn",
    year: 1953
  },
  {
    title: "Teapot",
    composer: "J.J. Johnson",
    year: 1949,
    contrafact: true
  },
  {
    title: "Tell Me a Bedtime Story",
    composer: "Herbie Hancock",
    year: 1969
  },
  {
    title: "Temptation",
    composer: "Nacio Herb Brown/Arthur Freed",
    year: 1933,
    latin: true
  },
  {
    title: "Tempus Fugit",
    composer: "Bud Powell",
    year: 1949
  },
  {
    title: "Tenderly",
    composer: "Walter Gross/Jack Lawrence",
    year: 1946,
    ballad: true
  },
  {
    title: "Teo",
    composer: "Thelonious Monk",
    year: 1964
  },
  {
    title: "Thanks for the Memory",
    composer: "Ralph Rainger/Leo Robin",
    year: 1938
  },
  {
    title: "That Old Black Magic",
    composer: "Harold Arlen/Johnny Mercer",
    year: 1942
  },
  {
    title: "That Old Feeling",
    composer: "Sammy Fain/Lew Brown",
    year: 1937
  },
  {
    title: "That Tired Routine Called Love",
    composer: "Matt Dennis/Ted Steele",
    year: 1943
  },
  {
    title: "That's All",
    composer: "Bob Haymes & Alan Brandt",
    year: 1952,
    ballad: true
  },
  {
    title: "The Best Is Yet to Come",
    composer: "Cy Coleman/Carolyn Leigh",
    year: 1959
  },
  {
    title: "The Best Thing For You (Would Be Me)",
    composer: "Irving Berlin",
    year: 1950
  },
  {
    title: "The Best Things in Life Are Free",
    composer: "Ray Henderson/Buddy DaSilva & Lew Brown",
    year: 1927
  },
  {
    title: "The Boy Next Door",
    composer: "Hugh Martin/Ralph Blane",
    year: 1944,
    waltz: true
  },
  {
    title: "The Breeze and I",
    composer: "Ernesto Lecuona/Emilio de Torre & Al Stillman",
    year: 1928,
    latin: true
  },
  {
    title: "The Chase",
    composer: "Tadd Dameron",
    year: 1947
  },
  {
    title: "The Chipmunk Song (Christmas Don't Be Late)",
    composer: "David Seville",
    year: 1958,
    holiday: true
  },
  {
    title: "The Christmas Song",
    composer: "Bob Wells & Mel Torme",
    year: 1945,
    holiday: true
  },
  {
    title: "The Christmas Waltz",
    composer: "Jule Styne/Sammy Cahn",
    year: 1954,
    holiday: true
  },
  {
    title: "The End of a Love Affair",
    composer: "Edward C. Redding",
    year: 1950
  },
  {
    title: "The Eternal Triangle",
    composer: "Sonny Stitt",
    year: 1957,
    rhythm: true
  },
  {
    title: "The Eye of the Hurricane",
    composer: "Herbie Hancock",
    year: 1965,
    blues: true,
    minor: true
  },
  {
    title: "The Feeling of Jazz",
    composer: "Duke Ellington/Bobby Troup",
    year: 1962
  },
  {
    title: "The First Noel",
    composer: "William B. Sandys & Davies Gilbert",
    year: 1823,
    holiday: true
  },
  {
    title: "The Froof (The Fruit)",
    composer: "Bud Powell",
    year: 1951
  },
  {
    title: "The Gentle Rain",
    composer: "Luiz Bonfá/Matt Dubey",
    year: 1965,
    latin: true
  },
  {
    title: "The Girl from Ipanema",
    composer: "Antonio Carlos Jobim",
    year: 1963,
    latin: true
  },
  {
    title: "The Good Life",
    composer: "Sacha Distel & Jack Reardon",
    year: 1962
  },
  {
    title: "The Gypsy",
    composer: "Billy Reid",
    year: 1945
  },
  {
    title: "The Hymn",
    composer: "Charlie Parker",
    year: 1947,
    blues: true
  },
  {
    title: "The Inchworm",
    composer: "Frank Loesser",
    year: 1952,
    waltz: true
  },
  {
    title: "The Jitterbug Waltz",
    composer: "Fats Waller",
    year: 1942,
    waltz: true
  },
  {
    title: "The Kicker",
    composer: "Joe Henderson",
    year: 1967,
    blues: true
  },
  {
    title: "The Lady Is a Tramp",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1937
  },
  {
    title: "The Lamp is Low",
    composer: "Peter DeRose & Shefter/Mitchell Parish",
    year: 1939
  },
  {
    title: "The Last Time I Saw Paris",
    composer: "Jerome Kern/Oscar Hammerstein II",
    year: 1940
  },
  {
    title: "The Little Drummer Boy",
    composer: "Katherine Kennicott Davis",
    year: 1941,
    holiday: true
  },
  {
    title: "The Maestro",
    composer: "Cedar Walton",
    year: 1977
  },
  {
    title: "The Man I Love",
    composer: "George Gershwin/Ira Gershwin",
    year: 1924
  },
  {
    title: "The Masquerade is Over",
    composer: "Allie Wrubel/Herb Magidson",
    year: 1938
  },
  {
    title: "The Maze",
    composer: "Herbie Hancock",
    year: 1962
  },
  {
    title: "The Mooche",
    composer: "Duke Ellington/Irving Mills",
    year: 1929,
    blues: true,
    minor: true
  },
  {
    title: "The More I See You",
    composer: "Harry Warren/Mack Gordon",
    year: 1945
  },
  {
    title: "The Most Beautiful Girl in the World",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1935,
    waltz: true
  },
  {
    title: "The Natives are Restless Tonight",
    composer: "Horace Silver",
    year: 1964,
    blues: true,
    minor: true
  },
  {
    title: "The Nearness of You",
    composer: "Hoagy Carmichael/Ned Washington",
    year: 1937
  },
  {
    title: "The Night Has a Thousand Eyes",
    composer: "Jerry Brainin/Buddy Bernier",
    year: 1948
  },
  {
    title: "The Night We Called It a Day",
    composer: "Matt Dennis/Tom Adair",
    year: 1941
  },
  {
    title: "The Peacocks",
    composer: "Jimmy Rowles",
    year: 1975,
    ballad: true
  },
  {
    title: "The Pendulum at Falcon's Lair",
    composer: "Oscar Pettiford",
    year: 1953,
    rhythm: true
  },
  {
    title: "The Plain But the Simple Truth",
    composer: "Oscar Pettiford",
    year: 1959,
    blues: true
  },
  {
    title: "The Rubber Man",
    composer: "Cedar Walton",
    year: 1983
  },
  {
    title: "The Ruby and the Pearl",
    composer: "Jay Livingston/Ray Evans",
    year: 1952
  },
  {
    title: "The Sage",
    composer: "Mulgrew Miller",
    year: 1986
  },
  {
    title: "The Scene Changes",
    composer: "Bud Powell",
    year: 1958,
    rhythm: true
  },
  {
    title: "The Scene is Clean",
    composer: "Tadd Dameron",
    year: 1956
  },
  {
    title: "The Second Time Around",
    composer: "Jimmy Van Heusen/Sammy Cahn",
    year: 1960
  },
  {
    title: "The Serpent's Tooth",
    composer: "Miles Davis",
    year: 1953,
    rhythm: true
  },
  {
    title: "The Shadow of Your Smile",
    composer: "Johnny Mandel/Paul Francis Webster",
    year: 1965,
    latin: true
  },
  {
    title: "The Sheik of Araby",
    composer: "Ted Snyder/Harry B. Smith & Francis Wheeler",
    year: 1921
  },
  {
    title: "The Sidewinder",
    composer: "Lee Morgan",
    year: 1959
  },
  {
    title: "The Single Petal of a Rose",
    composer: "Duke Ellington",
    year: 1959,
    ballad: true
  },
  {
    title: "The Song Is You",
    composer: "Jerome Kern/Oscar Hammerstein II",
    year: 1932
  },
  {
    title: "The Squirrel",
    composer: "Tadd Dameron",
    year: 1947,
    blues: true
  },
  {
    title: "The St. Vitus Dance",
    composer: "Horace Silver",
    year: 1959
  },
  {
    title: "The Star-Crossed Lovers",
    composer: "Billy Strayhorn & Duke Ellington",
    year: 1944,
    ballad: true
  },
  {
    title: "The Surrey with the Fringe on Top",
    composer: "Richard Rodgers/Oscar Hammerstein II",
    year: 1943,
    miles: true
  },
  {
    title: "The Tadd Walk",
    composer: "Tadd Dameron",
    year: 1947
  },
  {
    title: "The Theme",
    composer: "Miles Davis",
    year: 1956,
    rhythm: true
  },
  {
    title: "The Things We Did Last Summer",
    composer: "Jule Styne/Sammy Cahn",
    year: 1946
  },
  {
    title: "The Thrill is Gone",
    composer: "Ray Henderson/Lew Brown",
    year: 1931,
    ballad: true
  },
  {
    title: "The Touch of Your Lips",
    composer: "Ray Noble",
    year: 1936
  },
  {
    title: "The Very Thought of You",
    composer: "Ray Noble",
    year: 1934,
    ballad: true
  },
  {
    title: "The Way You Look Tonight",
    composer: "Jerome Kern/Dorothy Fields",
    year: 1936,
    sinatra: true
  },
  {
    title: "Thelonious",
    composer: "Thelonious Monk",
    year: 1947,
    rhythm: true
  },
  {
    title: "Them There Eyes",
    composer: "Maceo Pinkard, Doris Tauber, William G. Tracey",
    year: 1930
  },
  {
    title: "Theme for Ernie",
    composer: "Fred Lacey",
    year: 1958
  },
  {
    title: "Theme for Red",
    composer: "Cedar Walton",
    year: 1985,
    rhythm: true
  },
  {
    title: "Then I'll Be Tired of You",
    composer: "Arthur Schwartz/Yip Harburg",
    year: 1934
  },
  {
    title: "There is No Greater Love",
    composer: "Isham Jones/Marty Symes",
    year: 1936
  },
  {
    title: "There Will Never Be Another You",
    composer: "Harry Warren/Mack Gordon",
    year: 1942
  },
  {
    title: "There's a Small Hotel",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1936
  },
  {
    title: "There's Danger in Your Eyes, Cherie",
    composer: "Peter Wendling/Harry Richman & Jack Meskill",
    year: 1929
  },
  {
    title: "There's No You",
    composer: "Hal Hopper/Tom Adair",
    year: 1944
  },
  {
    title: "These Foolish Things",
    composer: "Jack Strachey & Harry Link/Eric Maschwitz",
    year: 1936,
    ballad: true
  },
  {
    title: "They All Laughed",
    composer: "George Gershwin/Ira Gershwin",
    year: 1937
  },
  {
    title: "They Can't Take That Away From Me",
    composer: "George Gershwin/Ira Gershwin",
    year: 1937
  },
  {
    title: "They Didn't Believe Me",
    composer: "Jerome Kern",
    year: 1914
  },
  {
    title: "Think of One",
    composer: "Thelonious Monk",
    year: 1953
  },
  {
    title: "This Christmas",
    composer: "Donny Hathaway",
    year: 1971,
    holiday: true
  },
  {
    title: "They Say It's Wonderful",
    composer: "Irving Berlin",
    year: 1946,
    ballad: true
  },
  {
    title: "Things Ain't What They Used to Be",
    composer: "Mercer Ellington/Ted Persons",
    year: 1942,
    blues: true
  },
  {
    title: "This Can't Be Love",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1938
  },
  {
    title: "This Heart of Mine",
    composer: "Harry Warren/Arthur Freed",
    year: 1946
  },
  {
    title: "This Is Always",
    composer: "Harry Warren/Mack Gordon",
    year: 1946,
    ballad: true
  },
  {
    title: "This Is New",
    composer: "Kurt Weill/Ira Gershwin",
    year: 1941
  },
  {
    title: "This is No Laughing Matter",
    composer: "Al Frisch/Van Loman & Martin Block",
    year: 1941,
    ballad: true
  },
  {
    title: "This Year's Kisses",
    composer: "Irving Berlin",
    year: 1937
  },
  {
    title: "This Time The Dream's On Me",
    composer: "Harold Arlen/Johnny Mercer",
    year: 1941
  },
  {
    title: "Thou Swell",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1927
  },
  {
    title: "Three and One",
    composer: "Thad Jones",
    year: 1958
  },
  {
    title: "Three Bags Full",
    composer: "Herbie Hancock",
    year: 1962
  },
  {
    title: "Three Coins in the Fountain",
    composer: "Jule Styne/Sammy Cahn",
    year: 1954
  },
  {
    title: "Three Little Words",
    composer: "Harry Ruby/Bert Kalmar",
    year: 1930
  },
  {
    title: "Thriving on a Riff",
    composer: "Charlie Parker",
    year: 1945,
    rhythm: true
  },
  {
    title: "Tico Tico",
    composer: "Zequinha de Abreu",
    year: 1917,
    latin: true
  },
  {
    title: "Tiger Rag",
    composer: "The Original Dixieland Jazz Band/Harry Decosta",
    year: 1917
  },
  {
    title: "Time After Time",
    composer: "Jule Styne/Sammy Cahn",
    year: 1947
  },
  {
    title: "Time on My Hands",
    composer: "Vincent Youmans/Harold Adamson & Mack Gordon",
    year: 1930
  },
  {
    title: "Time Was",
    composer: "Miguel Prado/Gabriel Luna & Bob Russell",
    year: 1936
  },
  {
    title: "Tin Tin Deo",
    composer: "Dizzy Gillespie & Chano Pozo",
    year: 1947,
    latin: true
  },
  {
    title: "Tommy's Ballad",
    composer: "Barry Harris",
    year: 1979
  },
  {
    title: "Too Close for Comfort",
    composer: "Jerry Bock, George David Weiss, Larry Holofcener",
    year: 1956
  },
  {
    title: "Too Late Now",
    composer: "Burton Lane/Alan Jay Lerner",
    year: 1950,
    ballad: true
  },
  {
    title: "Too Marvelous for Words",
    composer: "Richard A. Whiting/Johnny Mercer",
    year: 1937
  },
  {
    title: "Too Young to Go Steady",
    composer: "Jimmy McHugh/Harold Adamson",
    year: 1955,
    ballad: true
  },
  {
    title: "Topsy",
    composer: "Edgar William Battle & Eddie Durham",
    year: 1937
  },
  {
    title: "Topsy Turvy",
    composer: "Bud Powell",
    year: 1956
  },
  {
    title: "Toys",
    composer: "Herbie Hancock",
    year: 1968
  },
  {
    title: "Trane's Blues (Vierd Blues)",
    composer: "Miles Davis",
    year: 1953,
    blues: true
  },
  {
    title: "Travelin' Light",
    composer: "James R. Mundy/Johnny Mercer",
    year: 1943,
    ballad: true
  },
  {
    title: "Trinkle Tinkle",
    composer: "Thelonious Monk",
    year: 1952
  },
  {
    title: "Triste",
    composer: "Antonio Carlos Jobim",
    year: 1967,
    latin: true
  },
  {
    title: "Turquoise Twice",
    composer: "Cedar Walton",
    year: 1967
  },
  {
    title: "Tune Up",
    composer: "Miles Davis",
    year: 1953
  },
  {
    title: "Twilight Waltz (Midnight Waltz)",
    composer: "Cedar Walton",
    year: 1967,
    waltz: true
  },
  {
    title: "Two Bass Hit",
    composer: "John Lewis & Dizzy Gillespie",
    year: 1947,
    blues: true,
    miles: true
  },
  {
    title: "Two for the Road",
    composer: "Henry Mancini/Leslie Bricusse",
    year: 1967
  },
  {
    title: "Two Sleepy People",
    composer: "Hoagy Carmichael/Frank Loesser",
    year: 1938
  },
  {
    title: "U.M.M.G.",
    composer: "Billy Strayhorn",
    year: 1959
  },
  {
    title: "Ugetsu (Fantasy in D)",
    composer: "Cedar Walton",
    year: 1963
  },
  {
    title: "Ugly Beauty",
    composer: "Thelonious Monk",
    year: 1967,
    waltz: true
  },
  {
    title: "Un Poco Loco",
    composer: "Bud Powell",
    year: 1951
  },
  {
    title: "Una Mas",
    composer: "Kenny Dorham",
    year: 1963,
    latin: true
  },
  {
    title: "Undecided",
    composer: "Charlie Shavers/Sid Robin",
    year: 1939
  },
  {
    title: "Until the Real Thing Comes Along",
    composer: "Mann Holiner, Alberta Nichols, Saul Chapin/Sammy Cahn",
    year: 1936,
    ballad: true
  },
  {
    title: "Up Jumped Spring",
    composer: "Freddie Hubbard",
    year: 1962,
    waltz: true
  },
  {
    title: "Uranus",
    composer: "Walter Davis Jr.",
    year: 1979
  },
  {
    title: "Valse Hot",
    composer: "Sonny Rollins",
    year: 1956,
    waltz: true
  },
  {
    title: "Violets For Your Furs",
    composer: "Matt Dennis/Tom Adair",
    year: 1941,
    ballad: true
  },
  {
    title: "Visa",
    composer: "Charlie Parker",
    year: 1949,
    blues: true
  },
  {
    title: "Wabash",
    composer: "Cannonball Adderley",
    year: 1959
  },
  {
    title: "Wahoo",
    composer: "Benny Harris",
    year: 1945,
    contrafact: true
  },
  {
    title: "Wail",
    composer: "Bud Powell",
    year: 1949,
    rhythm: true
  },
  {
    title: "Walkin'",
    composer: "Richard Carpenter",
    year: 1949,
    blues: true,
    miles: true
  },
  {
    title: "Waltz for Debbie",
    composer: "Bill Evans/Gene Lees",
    year: 1956,
    waltz: true
  },
  {
    title: "Warm Valley",
    composer: "Duke Ellington/Bob Russell",
    year: 1940,
    ballad: true
  },
  {
    title: "Warming Up a Riff",
    composer: "Charlie Parker",
    year: 1945
  },
  {
    title: "Watermelon Man",
    composer: "Herbie Hancock",
    year: 1962,
    blues: true
  },
  {
    title: "Wave",
    composer: "Antonio Carlos Jobim",
    year: 1967,
    latin: true
  },
  {
    title: "We See",
    composer: "Thelonious Monk",
    year: 1954
  },
  {
    title: "We'll Be Together Again",
    composer: "Carl Fischer/Frankie Laine",
    year: 1945
  },
  {
    title: "Wee (Allen's Alley)",
    composer: "Charlie Parker",
    year: 1949,
    rhythm: true
  },
  {
    title: "Wee Dot",
    composer: "J. J. Johnson",
    year: 1947,
    blues: true
  },
  {
    title: "Well, You Needn't",
    composer: "Thelonious Monk",
    year: 1947
  },
  {
    title: "West Coast Blues",
    composer: "Wes Montgomery",
    year: 1960,
    waltz: true,
    blues: true
  },
  {
    title: "West End Blues",
    composer: "King Oliver",
    year: 1928,
    blues: true
  },
  {
    title: "What Am I Here For?",
    composer: "Duke Ellington/Frankie Laine",
    year: 1942
  },
  {
    title: "What Is There to Say?",
    composer: "Vernon Duke/Yip Harburg",
    year: 1933,
    ballad: true
  },
  {
    title: "What Is This Thing Called Love?",
    composer: "Cole Porter",
    year: 1930
  },
  {
    title: "What'll I Do?",
    composer: "Irving Berlin",
    year: 1923
  },
  {
    title: "What's New?",
    composer: "Bob Haggart/Johnny Burke",
    year: 1939,
    ballad: true
  },
  {
    title: "When I Fall In Love",
    composer: "Victor Young/Edward Heyman",
    year: 1952,
    miles: true,
    ballad: true
  },
  {
    title: "When I Grow Too Old To Dream",
    composer: "Sigmund Romberg/Oscar Hammerstein II",
    year: 1934
  },
  {
    title: "When It's Darkness on the Delta",
    composer: "Jerry Livingston/Marty Symes & Al Neiburg",
    year: 1932
  },
  {
    title: "When It's Sleepy Time Down South",
    composer: "Clarence Muse, Leon T. Rene & Otis J. Rene, Jr.",
    year: 1931,
    ballad: true
  },
  {
    title: "When Lights Are Low",
    composer: "Benny Carter/Spencer Williams",
    year: 1936,
    miles: true
  },
  {
    title: "When You Wish Upon a Star",
    composer: "Leigh Harline/Ned Washington",
    year: 1940,
    ballad: true
  },
  {
    title: "When You're Smiling",
    composer: "Mark Fisher & Larry Shay/Joe Goodwin",
    year: 1928
  },
  {
    title: "When Your Lover Has Gone",
    composer: "Einar Aaron Swan",
    year: 1931
  },
  {
    title: "Where Are You?",
    composer: "Jimmy McHugh/Harold Adamson",
    year: 1937
  },
  {
    title: "Where Or When",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1937
  },
  {
    title: "While My Lady Sleeps",
    composer: "Bronislaw Kaper/Gus Kahn",
    year: 1941
  },
  {
    title: "Whisper Not",
    composer: "Benny Golson",
    year: 1956
  },
  {
    title: "Whispering",
    composer: "John Schonberger/Malvin Schonberger & Richard Coburn",
    year: 1920
  },
  {
    title: "White Christmas",
    composer: "Irving Berlin",
    year: 1940,
    holiday: true
  },
  {
    title: "Who?",
    composer: "Jerome Kern/Oscar Hammerstein II & Otto Harbach",
    year: 1925
  },
  {
    title: "Who Can I Turn To (When Nobody Needs Me)?",
    composer: "Leslie Bricusse & Anthony Newley",
    year: 1964
  },
  {
    title: "Who Cares?",
    composer: "George Gershwin/Ira Gershwin",
    year: 1931
  },
  {
    title: "Who Do You Love, I Hope?",
    composer: "Irving Berlin",
    year: 1946
  },
  {
    title: "Who's Sorry Now?",
    composer: "Bert Kalmar & Ted Snyder/Harry Ruby",
    year: 1923
  },
  {
    title: "Why Do I Love You?",
    composer: "Jerome Kern/Oscar Hammerstein II",
    year: 1927
  },
  {
    title: "Why Was I Born?",
    composer: "Jerome Kern/Oscar Hammerstein II",
    year: 1929,
    ballad: true
  },
  {
    title: "Wild is Love",
    composer: "Ray Rasch & Dotty Wayne",
    year: 1960
  },
  {
    title: "Will You Still Be Mine?",
    composer: "Matt Dennis/Tom Adair",
    year: 1941
  },
  {
    title: "Willow Grove (Willow Groove)",
    composer: "Bud Powell",
    year: 1955,
    blues: true
  },
  {
    title: "Willow Weep for Me",
    composer: "Ann Ronell",
    year: 1932
  },
  {
    title: "Windows",
    composer: "Chick Corea",
    year: 1966,
    waltz: true
  },
  {
    title: "Winter Wonderland",
    composer: "Felix Bernard/Richard B. Smith",
    year: 1934,
    holiday: true
  },
  {
    title: "Wise One",
    composer: "John Coltrane",
    year: 1964
  },
  {
    title: "Witchcraft",
    composer: "Cy Coleman/Carolyn Leigh",
    year: 1957,
    sinatra: true
  },
  {
    title: "With a Song in My Heart",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1929
  },
  {
    title: "Without a Song",
    composer: "Vincent Youmans/Billy Rose & Edward Eliscu",
    year: 1929
  },
  {
    title: "Without a Word of Warning",
    composer: "Harry Revel/Mack Gordon",
    year: 1935
  },
  {
    title: "Woody'n You (Algo Bueno)",
    composer: "Dizzy Gillespie",
    year: 1943,
    miles: true
  },
  {
    title: "Work",
    composer: "Thelonious Monk",
    year: 1954
  },
  {
    title: "Would You Like to Take a Walk",
    composer: "Harry Warren/Mort Dixon & Billy Rose",
    year: 1930
  },
  {
    title: "Wouldn't It Be Loverly",
    composer: "Frederick Loewe/Alan Jay Lerner",
    year: 1956
  },
  {
    title: "Wrap Your Troubles in Dreamse",
    composer: "Harry Barris/Ted Koehler & Billy Moll",
    year: 1931
  },
  {
    title: "Yardbird Suite (What Price Love?)",
    composer: "Charlie Parker",
    year: 1946
  },
  {
    title: "Yesterdays",
    composer: "Jerome Kern/Otto Harbach",
    year: 1933
  },
  {
    title: "You and the Night and the Music",
    composer: "Arthur Schwartz/Howard Dietz",
    year: 1934
  },
  {
    title: "You Are My Sunshine",
    composer: "Jimmie Davis & Charles Mitchell",
    year: 1939
  },
  {
    title: "You Are Too Beautiful",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1932,
    ballad: true
  },
  {
    title: "You Do Something To Me",
    composer: "Cole Porter",
    year: 1929
  },
  {
    title: "You Don't Know What Love Is",
    composer: "Gene De Paul/Don Raye",
    year: 1941,
    ballad: true
  },
  {
    title: "You Go to My Head",
    composer: "J. Fred Coots/Haven Gillespie",
    year: 1938,
    ballad: true
  },
  {
    title: "You Make Me Feel So Young",
    composer: "Josef Myrow/Mack Gordon",
    year: 1946,
    sinatra: true
  },
  {
    title: "You Say You Care",
    composer: "Jule Styne/Leo Robin",
    year: 1949
  },
  {
    title: "You Stepped Out of a Dream",
    composer: "Nacio Herb Brown/Gus Kahn",
    year: 1940
  },
  {
    title: "You Took Advantage of Me",
    composer: "Richard Rodgers/Lorenz Hart",
    year: 1928
  },
  {
    title: "You Took the Words Right Out of My Heart",
    composer: "Ralph Rainger/Leo Robin",
    year: 1938
  },
  {
    title: "You'd Be So Nice To Come Home To",
    composer: "Cole Porter",
    year: 1943
  },
  {
    title: "You're a Mean One, Mr. Grinch",
    composer: "Albert Hague",
    year: 1966,
    holiday: true
  },
  {
    title: "You're Blasé",
    composer: "Ord Hamilton & Bruce Sievier",
    year: 1931
  },
  {
    title: "You're Getting To Be a Habit With Me",
    composer: "Harry Warren/Al Dubin",
    year: 1933
  },
  {
    title: "You're My Everything",
    composer: "Harry Warren & Joseph Young/Mort Dixon",
    year: 1931,
    miles: true,
    ballad: true
  },
  {
    title: "You're My Thrill",
    composer: "Jay Gorney/Sidney Clare",
    year: 1933,
    ballad: true
  },
  {
    title: "You've Changed",
    composer: "Carl Fischer/William Carey",
    year: 1942,
    ballad: true
  },
  {
    title: "Young and Foolish",
    composer: "Albert Hague/Arnold B. Horwitt",
    year: 1954,
    ballad: true
  },
  {
    title: "Yours is My Heart Alone",
    composer: "Franz Lehar/Fritz Lohner-Beda & Ludwig Herzer",
    year: 1929
  }
];
